import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewChild, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {SwitchBoard} from "../../services/SwitchBoard";
import {LogoService} from "../../services/LogoService";
import {LoadingService} from "../../services/LoadingService";
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, Router} from "@angular/router";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {PROVINCES} from "../../constants/Provinces.constants";
import {LOGIN_LOGO_CSS, TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ToastService} from "../../services/Toast.service";
import {TAX_PLANNING_TYPES} from "../../constants/tax-planning.constants";
import {StateService} from "../../services/StateService";
import {NumeralService} from "../../services/Numeral.service";
import {State} from "../../models/State";
import {ExportService} from "../../services/Export.service";
import {Session} from "../../services/Session";
import {PageTitleService} from "../../services/PageTitle";
import {v4 as uuid} from 'uuid';
import {environment} from "../../../environments/environment";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {catchError, takeUntil} from 'rxjs/operators';
import {forkJoin, of} from 'rxjs';
import {PlanStrategiesComponent} from "../plan-strategies/plan-strategies.component";
import {RoiPageComponent} from "../roi-page/roi-page.component";
import {RoiPresentationComponent} from "../roi-presentation/roi-presentation.component";
import {ClientPlanReportComponent} from "../client-plan-report/client-plan-report.component";
import {CashflowTimelineComponent} from "../cashflow-timeline/cashflow-timeline.component";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";
import {FeeLinesComponent} from "./fee-lines/fee-lines.component";
import {CashflowLinesComponent} from "./cashflow-lines/cashflow-lines.component";
import {TaxEstimatesInputsComponent} from "./tax-estimates-inputs/tax-estimates-inputs.component";
import {FormulaBuilderComponent} from "./formula-builder/formula-builder.component";
import {ViewTemplateComponent} from "./view-template/view-template.component";
import {UseTemplateComponent} from "./use-template/use-template.component";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {FoundationInit} from "../../directives/foundation.directive";
import {StateRateService} from "../../tpiq-services/state-rate.service";
import {DashboardUploadCreatePlanComponent} from "../core-focus/dashboard-upload-create-plan/dashboard-upload-create-plan.component";
import { evaluate } from 'mathjs';
import {calculateEffectiveRate, isEffectiveRateMeaningful, recalculateTotalTax, shouldRecalculateEffectiveRate} from "../../utils-lib/tax-summary-recalc";
import {PlanCreationGuardService} from '../../tpiq-services/plan-creation-guard.service';
import {BasicPlanLimitService} from '../../tpiq-services/basic-plan-limit.service';
import {PlanCreationConfirmation} from '../../models/basic-plan-limit.model';

declare const _: any;
declare const jQuery: any;
declare const moment: any;

@Component({
  selector: 'app-client-plan-info',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, TpiqSelectDropdownComponent, PlanStrategiesComponent, RoiPageComponent, RoiPresentationComponent,
    ClientPlanReportComponent, CashflowTimelineComponent, FormatAmountPipe, FeeLinesComponent, CashflowLinesComponent, TaxEstimatesInputsComponent,
  FormulaBuilderComponent, ViewTemplateComponent, UseTemplateComponent, FroalaEditorModule, FileUploadModule, FoundationInit, DashboardUploadCreatePlanComponent],
  templateUrl: './client-plan-info.component.html',
  styleUrl: './client-plan-info.component.scss'
})
export class ClientPlanInfoComponent implements OnInit, OnDestroy {
  @ViewChild(FeeLinesComponent) feeLinesComponent: FeeLinesComponent;
  @ViewChild(TaxEstimatesInputsComponent) taxEstimatesComponent: TaxEstimatesInputsComponent;
  isValidFormula: any;
  taxStrategyId: string;
  clients: Array<any> = [];
  org: string;
  newTaxPlan: any = {
    ccropFlatRate: '21',
    customTaxRates: []
  };
  user: any;
  allTaxStrategies: Array<any> = [];
  groupedTaxStrategies: any = {};
  strategyTypes: any = {};
  clientTaxPlan: any = {};
  openDetail = false;
  defaultAssociatedWith: Array<any> = [];
  associatedWith: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate'},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate'},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate'},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate'},
    {id: '393a6f91-8222-11ef-bd9d-12ff30f54e53', name: 'Full Credit'},
    {id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate'},
    {id: 'ce08f4de-b7f2-449c-9bf8-9674fbf6d0d5', name: 'Qualified Dividends'}
  ];
  // stateAssociatedWith: Array<any> = [];
  editing: any = {};
  temp: any = {};
  dataLoaded = false;
  reveal: any = {
    addStrategy: false,
    extraOptions: false,
    fromulaCalculator: false,
    closePeriod: false,
    publishtoggle: false,
    showTemplates: false,
    goalDateUpdateForPayPerPlan: false,
    morePlanAttachments: false,
    previewOfPlanDoc: false,
    returnUploadDisclaimer: false,
    openRapEdit: false,
    viewJson: false,
    viewQuestionarieDetails: false
  };

  // RAP Edit Mode Properties
  isRapEditMode = false;
  isRapMaximized = false;
  rapEditPlanId: string | null = null;
  rapEditClientId: string | null = null;
  rapEditPlanName: string | null = null;
  ocrViewJsonData: any;
  questionarieData: any;
  editingStrategy: any;
  clientsList: Array<any> = [];
  thirdPartiesList: Array<any> = [];
  clientUserId: string;
  currentStrategy: any = {};
  costLines: Array<any> = [];
  cashflowLines: Array<any> = [];
  tempNames: any = {};
  tableData: any = {};
  tableTooltips: any = {
    clientName: 'This can be potential or existing clients',
    strategyName: 'Click on the strategy name for details',
    relatedPartyType: 'This can be potential or existing entity types',
    amount: 'Before tax amount of the tax deduction or credit',
    roi: 'Plan amount multiplied by the associated rate. This field can be overriden as needed',
    sinceYear: 'First tax year you are applying strategy to',
    toYear: 'If the strategy is not indefinite, this is the last tax year it will apply to',
    goalDate: 'The goal date you are expecting to implement a given strategy. This field is required to create a associated task',
    associated: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client\'s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be'
  };
  columns: Array<any> = [
    {name: 'strategyName', title: 'Strategy', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: 'Click strategy name for details'},
    {name: 'strategyType', title: 'Category', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'clientName', title: 'Payor', type: 'badge-input-search', 'status-col': true, classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'relatedPartyType', title: 'Type', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'This can be potential or existing entity types.'},
    {name: 'associated', title: 'Fed Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
    {name: 'stateAssociated', title: 'State Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
    {name: 'amount', title: 'Plan Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Before tax amount of the tax deduction or credit.'},
    {name: 'roiAmount', title: 'Fed Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Plan amount multiplied by the associated rate. This field can be overridden as needed.'},
    {name: 'stateRoiAmount', title: 'State Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''},
    {name: 'sinceYear', title: 'Begin', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'},
    {name: 'toYear', title: 'End', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'},
    {name: 'goalDate', title: 'Goal Task Date', type: 'date', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, allowPastDate: true, initAlways: true, headerColumnDesc: 'The goal date you are expecting to implement a given strategy. This field is required to create a associated task.'}];
  strategySort: any = {};
  isLoading = false;
  hasStrategies = false;
  newStrategy: any = {};
  showRates: boolean;
  showNotes: boolean;
  showCostLines: boolean;
  showCashflow: boolean;
  duplicatingPlan = false;
  closingPeriodPlan = false;
  currentView = 'default';
  currentSectionView = 'plan-rates';

  popupChecklistObj: any = {};
  roiCostLines: Array<any> = [];
  hasROIData: boolean;
  roiData: any = {};
  views: Array<any> = [{name: 'Category'}, {name: 'Strategy'}, {name: 'Related Party'}];
  feePeriods: Array<any> = [{name: 'Monthly'}, {name: 'Yearly'}, {name: 'Custom'}];
  feeTypes: Array<any> = [{name: 'One Time'}, {name: 'Recurring'}, {name: 'Pre Paid'}, {name: 'Priceless'}, {name: 'Third Party'}];
  cashflowTypes: Array<any> = [{name: 'One Time'}, {name: 'Recurring'}];
  transactionTypes: Array<any> = [{name: 'Sender'}, {name: 'Receiver'}];
  cashflowFrequencyTypes: Array<any> = [{name: 'Monthly'}, {name: 'Yearly'}];
  orgName: string;
  years: Array<any> = [];
  planYears: Array<any> = [];
  filterYears: Array<any> = [];
  currentYear: number;
  roiFilterYear: string;
  roiGraphFilterYear: string;
  roiView: string;
  strategyFilterYear: any;
  orgLogo: string;
  showDesc: boolean;
  defaultStrategyId = '';
  defaultStateAssociatedId = '';
  tempCustomTaxRates: Array<any> = [];
  showField = true;
  editMode: boolean;
  tabs: any = {
    plan: true,
    roi: false,
    dashboard: false
  };
  scenarios: Array<any> = [];
  defaultScenarioId: string;
  defaultScenarioName: string;
  actions: Array<any> = [{
    name: 'Duplicate Plan',
  }, {
    name: 'Rename Plan',
  }, {
    name: 'Delete Plan',
  }, {
    name: 'Related Parties',
  }, {
    name: 'Invoice',
  }];
  basicRestrictionsActive = false;
  duplicatePlanName: string;
  entities: Array<any> = [];
  editorOptions = {
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Internal notes about this plan',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  disclaimerEditorOptions = {
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Disclaimer to be displayed to the client',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  reportEditorOptions = {
    heightMin: 100,
    heightMax: 200,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Why this applies to you',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  showYearFilter: boolean;
  selectedFilter: any = {id: 'All', name: 'All'};
  allAssociatedData: any = {};
  allStateAssociatedData: any = [];
  filteredStrategies: Array<any> = [];
  showAddCustomRateInPopup: boolean;
  newCustomRate: any = {
    id: '',
    name: '',
    rate: 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  newPlanName: string;
  client: any;
  types: Array<any> = TAX_PLANNING_TYPES;
  isMinimized = false;
  notesStrategyName: string;
  currentNotesStrategy: any = {};
  bgColor: string;

  destroy$: EventEmitter<void> = new EventEmitter<void>();
  publishStrategyType = false;
  publishCategoryType = false;
  publishRelatedPartyType = false;
  taxPlanName = '';
  unpublishValues: any = {
    strategy: false,
    category: false,
    relatedParty: false,
  };
  finalFormula = {
    displayValue: '',
    actualValue: '',
    displayValuesArray: [],
    actualValuesArray: []
  };
  fixedRatesArray: Array<any> = [
    {id: 'a627ccde-dd57-1090-cefa-fc965526a557', name: 'Effective Rate', rate: ''},
    {id: '82c36191-8d6f-39e7-f711-947591551608', name: 'Marginal Rate', rate: ''},
    {id: '5a314bc1-4534-0426-1db4-d18403485072', name: 'Cap Gain Rate', rate: ''},
    {id: '23a5e1b2-03cf-6675-2596-0952387d4b46', name: 'C Corp Flat Rate', rate: ''},
    {id: 'f637945b-e78e-11ef-a4a7-0e0adc17208f', name: 'Market Growth Rate', rate: ''},
    {id: 'ca57f1ef-ebb8-d007-66f5-59a3297f0502', name: 'SE Tax Rate', rate: ''}];
  formulaValid;
  sampleCalculatedTaxValue;
  formulaRatesNamesArray: Array<any> = [];
  formulaRatesIdsArray: Array<any> = [];
  allAssociatedFormulaRatesData: any = {};
  isCustomRateEdit = false;
  tempCustomRateObject: any = {
    id : '',
    name : '',
    rate : 0,
    formula: {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    }
  };
  indexOfTempCustomRateObject: any;

  freezPlan = false;
  freezPlanStrategies: Array<any> = [];
  planYearFilter: string;
  scenariosExist = true;
  fromTaskPage = false;
  fromCreateOrDuplicatePlan = false;
  clientDefaultYear: string;
  duplicatePlanYear: any;
  closeYearPlanName = '';
  showPlanNameForNewPlan = false;
  showPlanNameValidationMessage = false;
  currentEnvironment: any;
  showClientInfo = false;
  taxPlanYear: any;
  clientPortalAccess: boolean;
  protectedView = false;
  questionnaire: any = {};
  roiDefaultYear = false;
  currentRoiDefaultYear: any;
  states: Array<any>;
  allProvinces: Array<any> = PROVINCES.COUNTRY_PROVINCES;
  planFilterOptions: any = {
    year: '',
    plan: '',
    actual: false,
    dollarChange: false,
    percentageChange: false
  };
  showActualColumn = false;
  showDollarChangeColumn = false;
  showPercentageChangeColumn = false;
  estimatesAccess: boolean;
  presentationAccess: boolean;
  organizerAccess: boolean;
  useTemplateData: any;
  feePeriodType: any;
  cashflowStrategies: Array<any> = [];
  isPaidPlan = false;
  currentPlan: string;
  userReadOnly: any;
  clientPlans: any;
  displayLogo = true;
  clientPlanInfoType = 'notes';
  // Plan attachment changes
  uploader: FileUploader;
  ocrUploader: FileUploader;
  viewFile: any;
  couponSuccess = false;
  couponCode = '';
  planFiles: Array<any> = [];
  currentFile: any = {};
  documentToRemove: any;
  strategyNotes = 'For more information on these strategies, close out of this screen and open jAIne to discuss.';
  hasActualAmount : boolean = false; 
  isMerged : boolean = true;

  constructor(
    private _router: Router,
    private dialog: MatDialog,
    private _route: ActivatedRoute,
    private switchBoard: SwitchBoard,
    private logoService: LogoService,
    private stateService: StateService,
    private titleService: PageTitleService,
    private toastService: ToastService,
    private exportService: ExportService,
    private numeralService: NumeralService,
    private loadingService: LoadingService,
    private changeDetectorRef: ChangeDetectorRef,
    private taxPlanningService: TaxPlanningService,
    private manageTaxStrategiesServices: ManageTaxStrategiesServices,
    private qsService: QuestionnairesSurveysService,
    private stateRateService: StateRateService,
    private planCreationGuard: PlanCreationGuardService,
    private basicPlanLimits: BasicPlanLimitService,
  ) {}

  projectionAsstEnabled = false;
  private readonly PROJECTION_ASST_ORGS = new Set([
    'trialtaxplaniq',
    'stag-taxplaniq',
    'test-taxplan',
    'meyergroup',
    'meyertax',
    'tpiqdevbasic',
    'tpiqdevgrowth',
    'tpiqdevstandard',
  ]);

  ngOnInit(): void {
    this.user = Session.getUser();
    const orgCountryCode: any = Session.getUser().orgCountryCode || 'US';
    this.org = Session.getOrg();
    this.projectionAsstEnabled = this.PROJECTION_ASST_ORGS.has((this.org || '').toLowerCase());
    this.orgName = this.user.org || '';
    this.currentEnvironment = environment;
    this.orgLogo = this.logoService.getLoginLogoUrl();
    const orgCssArray = LOGIN_LOGO_CSS[this.org] || [];
    if (orgCssArray && orgCssArray.length > 0) {
      const orgCss = _.find(orgCssArray, {style: 'background-color'}) || {};
      this.bgColor = orgCss.value;
    }
    const accessInfo = Session.getUserAccessInfo();
    this.clientPortalAccess = accessInfo && accessInfo.clientPortalAccess;
    if (Session.getTaxPlanningProtectedView()) {
      this.protectedView = true;
    } else {
      this.protectedView = false;
      Session.setTaxPlanningProtectedView(this.protectedView);
    }
    this.filterStates(orgCountryCode);
    this.defaultAssociatedWith = _.cloneDeep(this.associatedWith);
    this._route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params.fromTaskPage){
        this.fromTaskPage = true;
      } else {
        this.fromTaskPage = false;
      }
      if (params.fromCreateOrDuplicatePlan){
        this.fromCreateOrDuplicatePlan = true;
      } else {
        this.fromCreateOrDuplicatePlan = false;
      }
    });
    this._route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.clientUserId = params.clientId;
      this.getSubscriptionInfo();
      if (params.action == 'overview') {
        this.showClientInfo = true;
        this.currentView = 'default';
        if (this.clientUserId){
          this.getClient();
        }
      } else {
        this.showClientInfo = false;
        if (this.fromTaskPage) {
          this.currentView = 'client_plan';
        } else if (params.planView) {
          this.currentView = params.planView;
        } else {
          this.currentView = 'client_plan';
        }
        this.taxStrategyId = params.taxPlanningId;
        this.taxPlanYear = params.taxPlanyear;
        this.planYearFilter = params.taxPlanyear;
        this.loadPlanDeletionEntitlement();
        this.fillYears();
        this.fillROIYears();
        this.setFileUploader();
        if (this.taxStrategyId) {
          this.taxStrategyId = this.taxStrategyId.split('?')[0];
        }
        if (this.clientUserId){
          this.getRequiredData();
        }
        this.isMinimized = false;
        this.newStrategy = {};
        this.newCustomRate = {
          id: '',
          name: '',
          rate: 0,
          formula: {
            displayValue: '',
            actualValue: '',
            displayValuesArray: [],
            actualValuesArray: []
          }
        };

      }
    });
    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Client Plan Page',
      id: 'CLIENT_PLAN_PAGE'
    });
    this.basicPlanLimits.invalidated$.pipe(takeUntil(this.destroy$)).subscribe(change => {
      if (!change.orgId || change.orgId === this.org) {
        this.loadPlanDeletionEntitlement();
      }
    });
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      this.handleBackButton();
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data){
        if (toast.data.type == 'taxPlan'){
          this.deleteScenario(toast.data);
        } else if (toast.data.type == 'customRate'){
          this.removeCustomRate(toast.data);
        } else if (toast.data.type == 'publishPlan'){
          this.updateStatus();
        } else if (toast.data.type == 'plan-payment') {
          this.payPerPlan(toast.data);
        }
      }
    });
    this.switchBoard.onToggleFeedback.next({
      display: true,
      pageName: 'Tax plan page'
    });
    this.switchBoard.onTaxPlanningClientAction.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      if (obj.action == 'update'){
        this.getClient(true);
      }
    });
    this.switchBoard.onTaxPlanningStrategyAction.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      if (obj.action == 'create'){
        if (obj.strategy) {
          this.fetchTaxStrategies(obj.strategy);
        } else {
          this.fetchTaxStrategies();
        }
      } else if (obj.action == 'update'){
      }
    });
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key == 'TAX_STRATEGY'){
      this.stateService.pop();
    }
  }

  getSubscriptionInfo() {
    this.taxPlanningService.getSubscriptionStatus(this.org, this.user.id).subscribe(subscription => {
      this.currentPlan = subscription.subscriptionStatus;
      this.userReadOnly = (subscription.plan && subscription.plan.toLowerCase().includes("pay-per-tax-plan") && this.taxPlanningService.getUserReadOnly());
      if (subscription.accessList && subscription.accessList.length > 0) {
        this.estimatesAccess = subscription.accessList.indexOf('Estimates') !== -1;
        this.presentationAccess = subscription.accessList.indexOf('Presentation') !== -1;
        this.organizerAccess = subscription.accessList.indexOf('Organizer') !== -1;
      }
    });
  }

  getRequiredData() {
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    const services = [];
    const obj = {
      fromIndex: -1
    };
    const failed = [];
    // forkJoin fails fast, so one bad call used to discard every result and leave
    // the blocking overlay on for good. Give each call its own fallback, then
    // render whatever came back. The result guards below already allow nulls.
    const guard = (index, request) => request.pipe(catchError(error => {
      console.error('getRequiredData call ' + index + ' failed', error);
      failed.push(index);
      return of(null);
    }));
    services.push(guard(0, this.taxPlanningService.getClient(Session.getOrg(), this.user.id, this.clientUserId, this.protectedView)));
    services.push(guard(1, this.taxPlanningService.getClientPlansList(Session.getOrg(), this.user.id, this.clientUserId)));
    services.push(guard(2, this.manageTaxStrategiesServices.getPaginatedTaxStrategies(this.org, this.user.id, obj, true, false)));
    services.push(guard(3, this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, null, null, null, this.protectedView)));
    services.push(guard(4, this.taxPlanningService.getCostLines(this.org, this.user.id, this.taxStrategyId)));
    services.push(guard(5, this.taxPlanningService.getCashflowLines(this.org, this.user.id, this.taxStrategyId)));
    forkJoin(...services)
      .subscribe({
        next: results => {
          this.loadingService.triggerLoadingEvent(false);
          if (results[0]) {
            this.formatClientData(results[0]);
          }
          if (results[1]) {
            this.clientPlans = results[1];
          }
          if (results[2]) {
            this.formatTaxStrategiesData(results[2]);
          }
          if (results[3]) {
            this.formatClientTaxPlanData(results[3]);
          }
          if (results[4]) {
            this.formatCostLinesData(results[4]);
          }
          if (results[5]) {
            this.formatCashflowLinesData(results[5]);
          }
          if (failed.indexOf(3) > -1) {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to load this tax plan. Please contact support.');
          } else if (failed.length > 0) {
            this.toastService.pop(TOAST_TYPE.error, 'Some of this plan could not be loaded.');
          }
        },
        error: error => {
          // Last resort. Never leave the overlay on.
          console.error('getRequiredData failed', error);
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to load this tax plan. Please contact support.');
        }
      });
  }

  getClientPlans(isPlanyearChanged?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClientPlans(this.org, this.user.id, this.clientUserId, this.planYearFilter)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.scenarios = response || [];
        this.scenariosExist = (this.scenarios && this.scenarios.length > 0) ? true : false;
        if (isPlanyearChanged) {
          if (this.scenarios && this.scenarios.length > 0) {
            this._router.navigate(['tax-planning', 'client', this.clientUserId, this.scenarios[0].id, this.planYearFilter, 'client_plan']);
          }
        }
        const scenario = _.find(this.scenarios, {id: this.taxStrategyId});
        this.defaultScenarioId = '';
        this.defaultScenarioName = scenario ? scenario.name : '';
        let pageTitle = this.clientTaxPlan.userName || '';
        pageTitle = (pageTitle) ? pageTitle : (this.client.firstName + ' ' + this.client.lastName);
        setTimeout(() => {
          this.defaultScenarioId = this.taxStrategyId;
          this.titleService.setPageTitle(pageTitle);
        });
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  setYear($event, costLine){
    costLine.year = $event.id;
  }

  setPeriod($event, costLine){
    costLine.frequency = $event.name;
  }

  setPeriodForCashflow($event, cashflow){
    cashflow.frequency = $event.name;
  }

  setFeeType($event, costLine){
    costLine.type = $event.name;
    costLine.frequency = "";
  }

  setCashflowType($event, cashflow, key){
    if (key == 'thirdPartyId') {
      cashflow[key] = $event.id;
    } else {
      cashflow[key] = $event.name;
    }
  }

  setCashflowStrategy($event, cashflow){
    cashflow.strategyId = $event.strategyId;
  }

  fillYears(){
    const startYear: any = _.toNumber(this.planYearFilter);
    const endYear: any = startYear + 10;
    for (let i = startYear; i < endYear; i++){
      this.years.push({id: i, name: i.toString()});
    }
  }

  fillROIYears(){
    this.filterYears = [];
    const startYear: any = _.toNumber(this.planYearFilter);
    const endYear: any = startYear + 10;
    for (let i = startYear; i <= endYear; i++){
      this.filterYears.push({id: i.toString(), name: i.toString()});
    }
  }

  filterData($event){
    this.strategyFilterYear = $event.id;
    this.showYearFilter = false;
    this.selectedFilter = {id: $event.id, name: $event.id};
    this.getClientTaxPlan($event.id);
  }

  displayYearFilter(value){
    setTimeout(() => {
      this.showYearFilter = value;
    }, 50);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getClient(refresh?){
    this.taxPlanningService.getClient(Session.getOrg(), this.user.id, this.clientUserId, this.protectedView)
      .subscribe(response => {
        const data = _.cloneDeep(response);
        this.formatClientData(response);
        if (refresh){
          this.getClientTaxPlan();
        }
      });
  }

  formatClientData(data) {
    this.client = data || {};
    this.clientsList = data.relatedParties || [];
    this.thirdPartiesList = data.thirdParties || [];
    this.getQuestionnaireDetails();
    if (!this.showClientInfo) {
      this.switchPage(this.currentView);
      this.switchSection(this.currentSectionView);
    } else {
      const title = this.client.firstName + ' ' + this.client.lastName;
      this.titleService.setPageTitle(title);
    }
  }

  handleBackButton(){
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key == 'client-overview'){
      this.stateService.pop();
      this._router.navigate(['tax-planning', 'clients', prevState.data.clientId, 'overview']);
    } else if (prevState && prevState.key != 'NEW_STRATEGY'){
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    } else if (prevState && prevState.key == 'NEW_STRATEGY'){
      this.stateService.pop();
      this._router.navigate([prevState.url], {queryParams: {fromCreateOrDuplicatePlan: true}});
    } else {
      this._router.navigate(['tax-planning', 'clients', prevState.data.clientId, 'overview']);
    }
  }

  showOCRResponse(file) {
    this.clearRightPaneContent();
    this.loadingService.triggerLoadingEvent(true);
    try{
      if (file.ocrResponse){
        const json = file.ocrResponse.replaceAll('\\n', '<br/>');
        const response = JSON.parse(json) || {};
        const taxStrategy = response.tax_strategy;
        if(file.progress === 100 && !taxStrategy){
          this.currentFile = {
            id: file.id,
            type: 'scanned',
            content: "Either your file is being scanned or could not scan the document."
          };
        } else {
          this.currentFile = {
            type: 'scanned',
            content: taxStrategy.text
          };
        }
        this.loadingService.triggerLoadingEvent(false);
      }
    } catch (error){
      this.loadingService.triggerLoadingEvent(false);
    }
  }

  clearRightPaneContent() {
    this.currentFile = {};
  }

  scanFile(file) {
    this.clearRightPaneContent();
    this.loadingService.triggerLoadingEvent(true);
    const payload = {
      firstName: Session.getUser().firstName,
      lastName: Session.getUser().lastName,
      userEmail: Session.getUser().id,
      clientFirstName: this.client.firstName,
      clientLastName: this.client.lastName,
      email: this.clientTaxPlan.userId,
      orgID: Session.getOrg(),
      template_type: '1040',
      planName: this.clientTaxPlan.name
    };
    this.taxPlanningService.scanFile(Session.getOrg(), Session.getUser().id, file.id, payload).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      file.ocrStatus = true;
      file.ocrProgress = 5;
      file.taskId = response.taskId;
      this.pollForStatus(file);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  pollForStatus(file){
    this.taxPlanningService.getOCRProgress(Session.getOrg(), Session.getUser().id, file.taskId)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
      file.progress = response.progress || 0;
      if (file.progress < 100){
        setTimeout(() => {
          this.pollForStatus(file);
        }, 10000);
      } else {
        this.getPlanFiles(true);
      }
    }, error => {});
  }

  fetchTaxStrategies(strategy?){
    const obj = {
      fromIndex: -1
    };
    this.loadingService.triggerLoadingEvent(true);
    this.manageTaxStrategiesServices.getPaginatedTaxStrategies(this.org, this.user.id, obj, true, false)
      .subscribe({
        next: (response) => {
          this.formatTaxStrategiesData(response, strategy);
          this.getClientTaxPlan();
          this.getCostLines();
        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  formatTaxStrategiesData(data, strategy?) {
    this.allTaxStrategies = [...data.strategies];
    this.filteredStrategies = [...this.allTaxStrategies];
    this.groupedTaxStrategies = _.groupBy(this.allTaxStrategies, function(strategy){
      strategy.strategyId = strategy.id;
      return strategy.type;
    });
    this.strategyTypes = _.uniq(_.map(this.allTaxStrategies, 'type'));
    if (strategy) {
      this.newStrategy.strategyId = strategy.id;
      if (strategy.associatedWith) {
        this.newStrategy.associatedWith = strategy.associatedWith;
        this.defaultStrategyId = strategy.associatedWith;
      } else {
        this.defaultStrategyId = '';
      }
    }
  }

  removeStrategy(clientTaxStrategy, index){
    clientTaxStrategy.strategies.splice(index, 1);
  }

  getClientTaxPlan(year?){
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, year, null, null, this.protectedView)
      .subscribe({
        next: (response) => {
          this.formatClientTaxPlanData(response);
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to load tax plan');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  formatClientTaxPlanData(data) {
    this.clientTaxPlan = data;

    let pageTitle = this.client.firstName + ' ' + this.client.lastName;
    pageTitle += (this.clientTaxPlan.name) ? (' / ' + this.clientTaxPlan.name) : '';
    this.titleService.setPageTitle(pageTitle);

    const strategiesList = _.cloneDeep(this.clientTaxPlan.strategies);
    this.cashflowStrategies = _.uniqBy(strategiesList, 'strategyId');
    this.planYearFilter = this.clientTaxPlan.taxYear;
    this.parseCustomRates();
    this.appendCustomRates(data);
    this.updateTaxRatesInFormula();
    this.dataLoaded = true;
    this.buildAssociatedObject();
    this.buildStateAssociatedObject();
    if (this.clientTaxPlan.archived) {
      this.freezPlan = true;
      this.formRowsDataForFreezingPlan();
    } else {
      this.freezPlan = false;
    }
    if (this.currentView == 'client_plan' && this.userReadOnly) {
      this.formRowsDataForFreezingPlan();
    }
    this.buildTableData(data.strategies || []);
  }

  updateTaxRatesInFormula() {
    const base = this;
    _.each(this.fixedRatesArray, function(obj){
      if (obj.name == 'Effective Rate'){
        obj.rate = base.clientTaxPlan.effectiveRate;
      } else if (obj.name == 'Marginal Rate'){
        obj.rate = base.clientTaxPlan.marginalRate;
      } else if (obj.name == 'Cap Gain Rate'){
        obj.rate = base.clientTaxPlan.capGainRate;
      } else if (obj.name == 'C Corp Flat Rate'){
        obj.rate = base.clientTaxPlan.ccropFlatRate;
      } else if (obj.name == 'Market Growth Rate'){
        obj.rate = base.clientTaxPlan.marketGrowthRate || 5;
      } else if (obj.name == 'SE Tax Rate'){
        obj.rate = base.clientTaxPlan.seTaxRate || 15.3;
      } else {
        return obj.rate;
      }
    });
  }

  private deserializeFormula(formula: any) {
    if (formula === undefined || formula === null) {
      return formula;
    }
    if (typeof formula === 'string') {
      try {
        return JSON.parse(formula);
      } catch (e) {
        return formula;
      }
    }
    return formula;
  }

  private isStateRate(customRate: any) {
    const rateType = customRate && customRate.formula && customRate.formula.type;
    return rateType === 'individual' || rateType === 'corporate';
  }

  parseCustomRates(){
    const base = this;
    _.each(this.clientTaxPlan.customTaxRates, function(customTaxRate){
      try{
        customTaxRate.formula = base.deserializeFormula(customTaxRate.formula);
      } catch (e){
        console.error('Failed to parse formula : ', e);
      }
    });
  }

  buildAssociatedObject(){
    const base = this;
    this.associatedWith = [...this.associatedWith];
    _.each(this.allTaxStrategies, function(obj){
      let strategyRates = [...base.associatedWith];
      if (obj.customTaxRates){
        const filteredCustomRates = _.chain(obj.customTaxRates)
          .map((customTaxRate) => {
            const parsedRate = _.cloneDeep(customTaxRate);
            try {
              parsedRate.formula = base.deserializeFormula(parsedRate.formula);
            } catch (e) {
              console.error('Failed to parse formula : ', e);
            }
            return parsedRate;
          })
          .filter((customTaxRate) => !base.isStateRate(customTaxRate))
          .value();
        strategyRates = strategyRates.concat(filteredCustomRates);
      }
      base.allAssociatedData[obj.id] = strategyRates;
    });
  }

  buildStateAssociatedObject(){
    const data = [];
    if (this.clientTaxPlan && this.clientTaxPlan.customTaxRates.length > 0) {
      _.each(this.clientTaxPlan.customTaxRates, (customRate) => {
        const parsedRate = _.cloneDeep(customRate);
        parsedRate.formula = this.deserializeFormula(parsedRate.formula);
        data.push(parsedRate);
      });
    }
    data.push({id: '454ba189-8222-11ef-bd9d-12ff30f54e53', name: 'N/A'});
    this.allStateAssociatedData = _.uniqBy(data, 'id');
  }

  appendCustomRates(taxPlan){
    const base = this;
    this.associatedWith = _.cloneDeep(this.defaultAssociatedWith);
    _.each(taxPlan.customTaxRates, function(customRate){
      const parsedCustomRate = _.cloneDeep(customRate);
      parsedCustomRate.formula = base.deserializeFormula(parsedCustomRate.formula);
      const associated = _.find(base.associatedWith, {id: parsedCustomRate.id});
      if (associated){
        associated.rate = parsedCustomRate.rate;
      } else {
        if (!base.isStateRate(parsedCustomRate)) {
          base.associatedWith.push(parsedCustomRate);
        }
      }
    });
    this.associatedWith = [...this.associatedWith];
    this.buildAssociatedObject();
  }

  addDefaultStrategies(){
    const base = this;
    if (this.clientTaxPlan && this.clientTaxPlan.strategyTypes.length == 0){
      _.each(base.strategyTypes, function(type){
        base.clientTaxPlan.strategyTypes.push({
          type,
          strategies: [{
            amount: 0,
            roiAmount: 0
          }]
        });
      });
    } else {
      const existingTypes = _.map(this.clientTaxPlan.strategyTypes, 'type');
      const newTypesToAdd = _.differenceWith(this.strategyTypes, existingTypes, _.isEqual);
      _.each(newTypesToAdd, function(type){
        base.clientTaxPlan.strategyTypes.push({
          type,
          strategies: [{
            amount: 0,
            roiAmount: 0
          }]
        });
      });
    }
  }

  toggleDetail(){
    this.openDetail = !this.openDetail;
  }

  updateClient($event, strategies, index){
    strategies[index].clientId = $event.id;
  }

  calculateResultAmount(strategy, isStateRateCalcReq?){
    const associatedWithId = strategy.associatedWith;
    if (associatedWithId){
      const multiplierRate = this.getRate(strategy, associatedWithId);
      if (strategy.actualAmount) {
        strategy.roiAmount = multiplierRate * strategy.actualAmount;
      } else {
        strategy.roiAmount = multiplierRate * strategy.amount;
      }
      strategy.overriden = false;
    } else {
      strategy.roiAmount = (strategy.actualAmount) ? strategy.actualAmount : strategy.amount;
    }
    if (isStateRateCalcReq) {
      this.calculateStateResultAmount(strategy);
    }
  }

  calculateStateResultAmount(strategy){
    const stateAssociatedWithId = strategy.stateAssociatedWith;
    if (stateAssociatedWithId){
      const multiplierRate = this.getStateRate(strategy, stateAssociatedWithId);
      strategy.stateRoiAmount = multiplierRate * ((strategy.actualAmount) ? strategy.actualAmount : strategy.amount);
      strategy.stateOrverriden = false;
    } else {
      strategy.stateRoiAmount = 0;
    }
  }

  triggerRecalculation(){
    const base = this;
    _.each(this.clientTaxPlan.strategies, function(strategy){
      base.calculateResultAmount(strategy);
      base.calculateStateResultAmount(strategy);
    });
  }

  updateTotals(clientTaxStrategy, strategy){
    clientTaxStrategy.totalAmount = _.sumBy(clientTaxStrategy.strategies, 'roiAmount');
  }

  updateClientStrategy(){
    this.stringifyCustomRateFormulas();
    // if (this.clientTaxPlan && this.clientTaxPlan.reportCustomization) {
    //   this.clientTaxPlan.reportCustomization = this.clientTaxPlan.reportCustomization
    //     .replace(/<\/?p[^>]*>/g, '')
    //     .trim();
    // }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateTaxPlanForClient(this.org, this.user.id, this.clientTaxPlan.id, this.clientTaxPlan)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Tax Plan Updated Successfully');
          this.getClientTaxPlan();
        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try{
            const errorObj = JSON.parse(error);
            this.toastService.pop(TOAST_TYPE.error, errorObj.message);
          } catch (err){
            this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Tax Plan');
          }
        }
      });
  }

  updateClientStrategyDisclaimer(){
    this.updateClientStrategy();
    this.hideReveal('planInfo');
  }

  stringifyCustomRateFormulas(){
    _.each(this.clientTaxPlan.customTaxRates, (customTaxRate) => {
      try{
        if (!_.isString(customTaxRate.formula)) {
          customTaxRate.formula = JSON.stringify(customTaxRate.formula);
        }
      } catch (e){}
    });
  }

  getRate(strategy, associatedWithId){
    let rates = this.allAssociatedData[strategy.strategyId] || [];
    if (rates.length == 0){
      rates = this.associatedWith;
    }
    const obj = _.find(rates, {id: associatedWithId});
    if (obj){
      if (obj.name == 'Effective Rate'){
        return this.clientTaxPlan.effectiveRate / 100;
      } else if (obj.name == 'Marginal Rate'){
        return this.clientTaxPlan.marginalRate / 100;
      } else if (obj.name == 'Cap Gain Rate'){
        return this.clientTaxPlan.capGainRate / 100;
      } else if (obj.name == 'C Corp Flat Rate'){
        return this.clientTaxPlan.ccropFlatRate / 100;
      } else if (obj.name == 'Market Growth Rate'){
        return (this.clientTaxPlan.marketGrowthRate || 5) / 100;
      } else if (obj.name == 'SE Tax Rate'){
        return (this.clientTaxPlan.seTaxRate || 15.3) / 100;
      } else if (obj.name == 'Full Credit'){
        // Here Full Credit means 100% credit i.e 100/100
        return 1;
      } else if (obj.name == 'N/A'){
        return 0;
      } else if (obj.formula && obj.formula.actualValuesArray && obj.formula.actualValuesArray.length > 0) {
        const fromula = (_.isString(obj.formula)) ? JSON.parse(obj.formula) : obj.formula;
        let calcVal = '';

        if (fromula.displayValuesArray && fromula.displayValuesArray.length > 0) {
          _.each(fromula.displayValuesArray, (value) => {
            if (value == 'Effective Rate') {
              calcVal += this.clientTaxPlan.effectiveRate;
            } else if (value == 'Marginal Rate'){
              calcVal += this.clientTaxPlan.marginalRate;
            } else if (value == 'Cap Gain Rate'){
              calcVal += this.clientTaxPlan.capGainRate;
            } else if (value == 'C Corp Flat Rate'){
              calcVal += this.clientTaxPlan.ccropFlatRate;
            } else if (value == 'Market Growth Rate'){
              calcVal += this.clientTaxPlan.marketGrowthRate || 5;
            } else if (value == 'SE Tax Rate'){
              calcVal += this.clientTaxPlan.seTaxRate || 15.3;
            } else {
              calcVal += value;
            }
          });
        }
        const result = calcVal ? evaluate(calcVal) : 0;
        return result ? (result / 100) : 1;
      }  else {
        return obj.rate / 100;
      }
    } else {
      return 0;
    }
  }

  getStateRate(strategy, stateAssociatedWithId){
    if (this.allStateAssociatedData && this.allStateAssociatedData.length > 0) {
      const obj = _.find(this.allStateAssociatedData, {id: stateAssociatedWithId});
      if (obj){
        let stateRate: any;
        if (obj.name === 'Full Credit') {
          // Here Full Credit means 100% credit i.e 100/100
          stateRate = 1;
        } else if (obj.name === 'N/A') {
          stateRate = 0;
        } else {
          stateRate = obj.rate / 100;
        }
        return stateRate;
      } else {
        return 0;
      }
    }
  }

  toggleField(key, value, rate?){
    this.editing[key] = value;
    if (rate){
      this.tempNames[key] = rate.name;
      this.temp[key] = rate.rate;
    }
  }

  updateValue(key, isCustom?){
    if (isCustom){
      this.updateCustomTaxRate(key, true);
    } else {
      const previousTaxableIncome = this.clientTaxPlan.taxableIncome;
      const previousTotalTax = this.clientTaxPlan.totalTax;
      this.clientTaxPlan[key] = this.temp[key];
      if (key == "totalTax" && Number(this.temp[key]) !== Number(previousTotalTax)){
        // Total Tax now belongs to the user, so it is never replaced by a bracket
        // estimate later on. Only on a real change: opening the editor and
        // confirming the same figure is not an override.
        this.clientTaxPlan.totalTaxOverridden = true;
      }
      if(key == "totalTax" || key == "taxableIncome"){
        this.calculateRates(key, previousTaxableIncome)
      }
      this.updateTaxRatesInFormula();
      // reCalculateCustomRates() ends in triggerRecalcAndUpdatePlan(), so the
      // strategy lines are recalculated against the new rates and the plan is
      // saved. Do not add a second save here.
      this.reCalculateCustomRates();
      this.toggleField(key, false);
    }
  }

  calculateRates(type?, previousTaxableIncome?){

      if (type && type === 'taxableIncome') {
        this.clientTaxPlan.filingStatus = this.clientTaxPlan.filingStatus? this.clientTaxPlan.filingStatus : "Single";
      // Positive only: calculateMarginalRate() has no bracket that matches a
      // negative taxable income, so a business loss would leave the previous
      // positive rate on screen next to it.
      if (this.clientTaxPlan.taxableIncome > 0 && !isNaN(this.clientTaxPlan.taxableIncome)) {

        this.calculateMarginalRate();
        this.calculateCapGainsRate();

        // Total Tax follows the taxable-income change at the marginal rate,
        // anchored on the as-filed figure (1040 line 24). It cannot be rederived
        // outright: the filed number carries SE tax, NIIT, AMT, preferential
        // cap-gain rates and credits that a taxable-income figure does not know about.
        this.clientTaxPlan.totalTax = recalculateTotalTax({
          previousTaxableIncome: previousTaxableIncome,
          newTaxableIncome: this.clientTaxPlan.taxableIncome,
          currentTotalTax: this.clientTaxPlan.totalTax,
          marginalRate: this.clientTaxPlan.marginalRate,
          filingStatus: this.clientTaxPlan.filingStatus,
          totalTaxOverridden: this.clientTaxPlan.totalTaxOverridden
        });

      }
    }

      // Last, so numerator and denominator are both post-edit. Recomputing this
      // first left the rate as old Total Tax over new Taxable Income.
      if (shouldRecalculateEffectiveRate(this.clientTaxPlan.totalTax, this.clientTaxPlan.taxableIncome)){
        this.clientTaxPlan.effectiveRate = calculateEffectiveRate(this.clientTaxPlan.totalTax, this.clientTaxPlan.taxableIncome);
      }
  }

  /** Canonical rule: a taxable income of zero or less has no effective rate to show. */
  showEffectiveRate(){
    return isEffectiveRateMeaningful(this.clientTaxPlan?.taxableIncome);
  }

   calculateMarginalRate() {
    if (this.clientTaxPlan && this.clientTaxPlan.filingStatus) {
      const ti = Number(this.clientTaxPlan.taxableIncome);
      if (isNaN(ti)) {
        return;
      }

      // Chart-based brackets
      // Single / MFS
      if (this.clientTaxPlan.filingStatus === 'Single') {
        if (ti >= 0 && ti <= 12400) {
          this.clientTaxPlan.marginalRate = 10;
        } else if (ti >= 12401 && ti <= 50400) {
          this.clientTaxPlan.marginalRate = 12;
        } else if (ti >= 50401 && ti <= 105700) {
          this.clientTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.clientTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256225) {
          this.clientTaxPlan.marginalRate = 32;
        } else if (ti >= 256226 && ti <= 640600) {
          this.clientTaxPlan.marginalRate = 35;
        } else if (ti >= 640601) {
          this.clientTaxPlan.marginalRate = 37;
        }
      }

      else if (this.clientTaxPlan.filingStatus === 'MFS') {
        if (ti >= 0 && ti <= 12400) {
          this.clientTaxPlan.marginalRate = 10;
        } else if (ti >= 12401 && ti <= 50400) {
          this.clientTaxPlan.marginalRate = 12;
        } else if (ti >= 50401 && ti <= 105700) {
          this.clientTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.clientTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256225) {
          this.clientTaxPlan.marginalRate = 32;
        } else if (ti >= 256226 && ti <= 384350) {
          this.clientTaxPlan.marginalRate = 35;
        } else {
          this.clientTaxPlan.marginalRate = 37;
        }
      }

      // MFJ
      else if (this.clientTaxPlan.filingStatus === 'MFJ') {
        if (ti >= 0 && ti <= 24800) {
          this.clientTaxPlan.marginalRate = 10;
        } else if (ti >= 24801 && ti <= 100800) {
          this.clientTaxPlan.marginalRate = 12;
        } else if (ti >= 100801 && ti <= 211400) {
          this.clientTaxPlan.marginalRate = 22;
        } else if (ti >= 211401 && ti <= 403550) {
          this.clientTaxPlan.marginalRate = 24;
        } else if (ti >= 403551 && ti <= 512450) {
          this.clientTaxPlan.marginalRate = 32;
        } else if (ti >= 512451 && ti <= 768700) {
          this.clientTaxPlan.marginalRate = 35;
        } else if (ti >= 768701) {
          this.clientTaxPlan.marginalRate = 37;
        }
      }

      // Head of Household
      else if (this.clientTaxPlan.filingStatus === 'Head of Household') {
        if (ti >= 0 && ti <= 17700) {
          this.clientTaxPlan.marginalRate = 10;
        } else if (ti >= 17701 && ti <= 67450) {
          this.clientTaxPlan.marginalRate = 12;
        } else if (ti >= 67451 && ti <= 105700) {
          this.clientTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.clientTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256200) {
          this.clientTaxPlan.marginalRate = 32;
        } else if (ti >= 256201 && ti <= 640600) {
          this.clientTaxPlan.marginalRate = 35;
        } else  if (ti >= 640601){
          this.clientTaxPlan.marginalRate = 37;
        }
      }
       else if(this.clientTaxPlan.filingStatus === 'Estate' || this.clientTaxPlan.filingStatus === 'Trust') {
        if (ti >= 0 && ti <= 3300) {
          this.clientTaxPlan.marginalRate = 10;
        } else if (ti >= 3301 && ti <= 11700) {
          this.clientTaxPlan.marginalRate = 24;
        } else if (ti >= 11701 && ti <= 16000) {
          this.clientTaxPlan.marginalRate = 35;
        } else {
          this.clientTaxPlan.marginalRate = 37;
        }
      }
    }
  }

  calculateCapGainsRate() {
    // It will need to change this per tax year. Calculated based on cap gains table (https://taxfoundation.org/data/all/febural/2026-tax-brackets/)
    if (this.clientTaxPlan && this.clientTaxPlan.filingStatus) {
      const ti = Number(this.clientTaxPlan.taxableIncome);
      if (isNaN(ti)) {
        return;
      }

      // Long-term capital gains brackets (chart-based)
      // Unmarried (Single)
      if (this.clientTaxPlan.filingStatus === 'Single') {
        if (ti >= 0 && ti <= 49450) {
          this.clientTaxPlan.capGainRate = 0;
        } else if (ti >= 49451 && ti <= 545500) {
          this.clientTaxPlan.capGainRate = 15;
        } else {
          this.clientTaxPlan.capGainRate = 20;
        }
      }
      else if(this.clientTaxPlan.filingStatus === 'MFS'){
         if (ti >= 0 && ti <= 49450) {
          this.clientTaxPlan.capGainRate = 0;
        } else if (ti >= 49451 && ti <= 306850) {
          this.clientTaxPlan.capGainRate = 15;
        } else {
          this.clientTaxPlan.capGainRate = 20;
        }
      }

      // Married Filing Jointly
      else if (this.clientTaxPlan.filingStatus === 'MFJ') {
        if (ti >= 0 && ti <= 98900) {
          this.clientTaxPlan.capGainRate = 0;
        } else if (ti >= 98901 && ti <= 613700) {
          this.clientTaxPlan.capGainRate = 15;
        } else {
          this.clientTaxPlan.capGainRate = 20;
        }
      }

      // Head of Household
      else if (this.clientTaxPlan.filingStatus === 'Head of Household' || this.clientTaxPlan.filingStatus === 'HOH') {
        if (ti >= 0 && ti <= 66200) {
          this.clientTaxPlan.capGainRate = 0;
        } else if (ti >= 66201 && ti <= 579600) {
          this.clientTaxPlan.capGainRate = 15;
        } else if (ti >= 579601) {
          this.clientTaxPlan.capGainRate = 20;
        }
      }
      else if(this.clientTaxPlan.filingStatus === 'Estate' || this.clientTaxPlan.filingStatus === 'Trust') {
        if (ti >= 0 && ti <= 3300) {
          this.clientTaxPlan.capGainRate = 0;
        } else if (ti >= 3301 && ti <= 16250) {
          this.clientTaxPlan.capGainRate = 15;
        } else {
          this.clientTaxPlan.capGainRate = 20;
        }
      }
    }
  }
  
  

  getRateFormula(value) {
    const base = this;
    let formula = _.cloneDeep(value) || 0;
    _.each(this.fixedRatesArray, function(obj){
      formula = _.replace(formula, obj.id, obj.rate);
    });
    return formula;
  }

  propageCustomRateChange(customeRate){
    const taxPlanIndex: any = _.findIndex(this.clientTaxPlan.customTaxRates, function(rate) { return rate.id === customeRate.id; });
    if (taxPlanIndex != -1) {
      this.clientTaxPlan.customTaxRates[taxPlanIndex].rate = customeRate.rate;
      this.clientTaxPlan.customTaxRates[taxPlanIndex].name = customeRate.name;
      this.clientTaxPlan.customTaxRates[taxPlanIndex].formula = JSON.parse(customeRate.formula);
      const tempIndex = _.findIndex(this.associatedWith, {id: customeRate.id});
      if (tempIndex != -1){
        this.associatedWith[tempIndex].rate = customeRate.rate;
        this.associatedWith[tempIndex].name = customeRate.name;
        this.associatedWith = [...this.associatedWith];
      }
      this.buildAssociatedObject();
    }
  }

  updateName(index){
    if (this.tempNames[index]){
      this.clientTaxPlan.customTaxRates[index].name = this.tempNames[index];
      this.associatedWith = [...this.associatedWith, {
        id: this.clientTaxPlan.customTaxRates[index].id,
        name: this.clientTaxPlan.customTaxRates[index].name
      }];
    }
  }

  revertValue(key){
    this.temp[key] = 0;
    this.toggleField(key, false);
  }

  showOptions(clientTaxStrategy){
    this.editingStrategy = clientTaxStrategy;
    this.reveal.extraOptions = true;
  }

  stopPropagation($event){
    $event && $event.stopImmediatePropagation();
  }

  hideReveal(key, overrideMinimizeStatus?){
    this.defaultStrategyId = '';
    this.defaultStateAssociatedId = '';
    this.taxPlanName = '';
    if (overrideMinimizeStatus){
      this.editMode = false;
      this.newStrategy = {};
      this.isMinimized = false;
      this.newCustomRate = {
        id: '',
        name: '',
        rate: 0,
        formula: {
          displayValue: '',
          actualValue: '',
          displayValuesArray: [],
          actualValuesArray: []
        }
      };
    }
    if (key == 'closePeriod') {
      this.closeYearPlanName = '';
      this.showPlanNameValidationMessage = false;
    }
    if (key == 'duplicate-plan') {
      this.duplicatePlanName = '';
      this.duplicatePlanYear = '';
    }
    if (key == 'previewOfPlanDoc') {
      this.viewFile = '';
    }
    this.clientPlanInfoType = 'notes';
    this.reveal[key] = false;
  }

  minimizeReveal(key){
    this.editMode = false;
    this.isMinimized = true;
    this.reveal[key] = false;
  }

  updateExecutionDate($event, strategy){
    if ($event){
      strategy.executionDate = $event;
    }
  }

  addNewCostLine(){
    this.costLines.push({
      userId: this.clientUserId,
      frequency: 'Yearly',
      year: parseInt(this.planYearFilter),
      associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
    });
  }

  addNewCashflow(){
    this.cashflowLines.push({
      planId: this.clientTaxPlan.id,
      thirdPartyId: '',
      frequency: 'Yearly',
    });
  }

  validateCostLines(costData){
    const base = this;
    let isFineToSave = true;
    let showAssociatedError = false;
    _.each(costData, function(costLine){
      if (!costLine.type) {
        base.toastService.pop(TOAST_TYPE.error, 'Type cannot be empty');
        isFineToSave = false;
      }
      if (costLine.type == 'Recurring' && costLine.frequency == 'Custom'){
        if (!costLine.fromMonth) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Start date cannot be empty');
        } else if (!costLine.toMonth) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'End date cannot be empty');
        }
      }
      if (costLine.type != 'Priceless' && !costLine.year){
        isFineToSave = false;
        base.toastService.pop(TOAST_TYPE.error, 'Year cannot be empty');
      }
      if (costLine.type != 'Priceless' && costLine.type != 'Non Deductable' && !costLine.associatedWith){
        isFineToSave = false;
        showAssociatedError = true;
      }
    });
    if (showAssociatedError) {
      base.toastService.pop(TOAST_TYPE.error, 'Please select an associated with rate');
    }
    return isFineToSave;
  }

  updateCostLines(){
    const costLinesData = _.cloneDeep(this.costLines);
    _.each(costLinesData, function(cost) {
      if (cost.fromMonth) {
        cost.fromMonth = moment(cost.fromMonth).format('MM/DD/YYYY');
      }
      if (cost.toMonth) {
        cost.toMonth = moment(cost.toMonth).format('MM/DD/YYYY');
      }
    });
    if (!this.validateCostLines(costLinesData)){
      return false;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateCostLines(this.org, this.user.id, this.taxStrategyId, costLinesData)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Fees updated successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update Fees');
        }
      });
  }

  updateCashflowLines(){
    const cashflowinesData = _.cloneDeep(this.cashflowLines);
    if (!this.validateCashflowLines(cashflowinesData)){
      return false;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateCashflowLines(this.org, this.user.id, this.taxStrategyId, cashflowinesData)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Updated successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to Update');
        }
      });
  }

  validateCashflowLines(cashflowData){
    const base = this;
    let isFineToSave = true;
    _.each(cashflowData, (cashflow) => {
      if (!cashflow.type) {
        base.toastService.pop(TOAST_TYPE.error, 'Type cannot be empty');
        isFineToSave = false;
      }
      if (!cashflow.strategyId) {
        base.toastService.pop(TOAST_TYPE.error, 'Strategy cannot be empty');
        isFineToSave = false;
      }
      if (!cashflow.transactionType) {
        base.toastService.pop(TOAST_TYPE.error, 'Transaction type cannot be empty');
        isFineToSave = false;
      }
      if (!cashflow.thirdPartyId) {
        base.toastService.pop(TOAST_TYPE.error, 'Third Party cannot be empty');
        isFineToSave = false;
      }
    });
    return isFineToSave;
  }

  getCostLines(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getCostLines(this.org, this.user.id, this.taxStrategyId)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.formatCostLinesData(response);
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  formatCostLinesData(data) {
    this.costLines = [];
    if (!data || data.length == 0){
    } else {
      this.costLines = data;
      // _.each(this.costLines, function(cost) {
      //   if (cost.fromMonth) {
      //     cost.fromMonth = moment(cost.fromMonth);
      //   }
      //   if (cost.toMonth) {
      //     cost.toMonth = moment(cost.toMonth);
      //   }
      // });
    }
  }

  formatCashflowLinesData(data) {
    this.cashflowLines = [];
    if (!data || data.length == 0){
    } else {
      this.cashflowLines = data;
    }
  }

  removeCostLine(index){
    this.costLines.splice(index, 1);
  }

  removeCashflowLine(index){
    this.cashflowLines.splice(index, 1);
  }

  addNewCustomRate(){
    const obj = {
      id: '',
      name: '',
      rate: 0,
      formula: {
        actualValue: '',
        displayValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    };
    this.tempCustomTaxRates.push(obj);
    this.tempCustomRateObject = obj;
    this.isCustomRateEdit = false;
    this.indexOfTempCustomRateObject = -1;
    this.emptyFormulaFields();
  }

  buildTableData(data, refreshTable?){
    const base = this;
    this.tableData.options = {
      height: '75vh',
      selectorString: 'id',
      showSearch: false,
      searchString: ''
    };
    this.tableData.columns = [];
    this.tableData.columns = this.formatColumns(this.columns);
    this.tableData.columns.push({name: 'actions', title: '', type: 'html', classes: 'date-column actions-class text-right', sortable: false});
    this.tableData.rows = [];

    let rows = base.tableData.rows || [];
    if (refreshTable){
      rows = [];
    }
    data.forEach(function(task){
      const row = base.createTableRow(task);
      if (row.id){
        rows.push(row);
      }
    });
    if (rows.length > 0) {
      rows.push(this.createTotalSavingsRow());
    }
    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.strategySort, this.tableData.columns);

    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
    if (refreshTable){
      this.hasStrategies = false;
    }
    setTimeout(() => {
      base.hasStrategies = true;
      base.loadingService.triggerLoadingEvent(false);
    });
  }

  createTotalSavingsRow(isFreezedPlan?) {
    const cols: any = _.cloneDeep(this.columns);
    const row: any = {};
    const base = this;
    _.each(cols, function(column){
      column.type = 'html';
      if (column.name == 'strategyName'){
        if (isFreezedPlan) {
          row[column.name] = `Total`;
        } else {
          row[column.name] = `<span style='color: #14B5F0'>Total</span>`;
        }
      } else if (column.name == 'amount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.totalPlanAmount || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.totalPlanAmount || 0)) + `</span>`;
        }
      } else if (column.name == 'actualAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.actualTaxSavingsTotal || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.actualTaxSavingsTotal || 0)) + `</span>`;
        }
      } else if (column.name == 'dollarDifference'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', (base.clientTaxPlan.totalDollarDifference || 0));
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', (base.clientTaxPlan.totalDollarDifference || 0)) + `</span>`;
        }
      } else if (column.name == 'percentageDifference'){
        if (isFreezedPlan) {
          row[column.name] = base.clientTaxPlan.totalPercentageDifference + '%';
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.clientTaxPlan.totalPercentageDifference + `%</span>`;
        }
      } else if (column.name == 'roiAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', base.clientTaxPlan.totalAmount);
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', base.clientTaxPlan.totalAmount) + `</span>`;
        }
      } else if (column.name == 'stateRoiAmount'){
        if (isFreezedPlan) {
          row[column.name] = base.numeralService.format('$0,0', base.clientTaxPlan.totalStateTaxSavings);
        } else {
          row[column.name] = `<span style='color: #14B5F0'>` + base.numeralService.format('$0,0', base.clientTaxPlan.totalStateTaxSavings) + `</span>`;
        }
      } else {
        row[column.name] = '';
      }
    });
    row.isTotalRow = true;
    return row;
  }

  handleSortOrder(tasksSortOrder, columns) {
    _.each(columns, function(column) {
      column.sortType = tasksSortOrder[column.name];
    });
  }

  getTooltipHtmlClass(){
    return this.tableData.rows && this.tableData.rows.length == 0 ? 'bottomTooltiptext' : 'topTooltiptext';
  }

  getDescription(strategyLine){
    const strategy = _.find(this.allTaxStrategies, {id: strategyLine.strategyId});
    return strategy ? strategy.description : '';
  }

  formatColumns(columns){
    const base = this;
    const resultArray = [];
    _.each(columns, function(column){
      if (column.name == 'clientName'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.clientsList, placeholder: column.title, sortable: true, headerColumnDesc: 'This can be potential or existing clients. To make adjustments to your related parties, just go to the Actions icon and select “Related Parties”.'});
      } else if (column.name == 'associated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, 'conditional-column': true, data: base.allAssociatedData, 'row-condition': 'strategyId', displayKey: 'name', placeholder: column.title, sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'});
      } else if (column.name == 'stateAssociated'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.allStateAssociatedData, displayKey: 'name', placeholder: column.title, sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'});
      } else if (column.name == 'sinceYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'});
      } else if (column.name == 'toYear'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'badge-input-search', 'status-col': true, editable: true, displayName: 'name', full_name: 'name', background: 'colorCode', 'multi-dropdown': false, data: base.years, placeholder: column.title, sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'});
      } else if (column.name == 'type'){
        resultArray.push({name: column.name, title: column.title, classes: 'pointer table-header-badge-tooltip', type: 'normal', sortable: true});
      } else {
        resultArray.push(column);
      }
    });
    return resultArray;
  }

  getStrategy(strategyLine){
    const strategy = _.find(this.allTaxStrategies, {id: strategyLine.strategyId});
    return strategy ? strategy : {};
  }

  getRatesForThisStrategy(strategy){
    return this.allAssociatedData[strategy.strategyId] ? this.allAssociatedData[strategy.strategyId] : [];
  }

  createTableRow(strategy) {
    const base = this;
    const row: any = {};
    const tooltipClass = base.getTooltipHtmlClass();
    _.each(strategy, function(value, key){
      if (key == 'strategyName') {
        if (strategy[key]){
          if (strategy.locked){
            row[key] = `<a class='actionOnId' data-action='info'><i class="icon ion-ios-locked-outline" style="color: #F06459; margin-right: 5px;"></i><span>${strategy[key]}</span></a>`;
          } else{
            row[key] = `<a class='actionOnId' data-action='info'><span>${strategy[key]}</span></a>`;
          }
        }
      } else if (key == 'strategyId') {
        const name = base.getStrategy(strategy).name;
        row[key] = strategy[key];
        row.strategyName = `<a class='actionOnId' data-action='info'><span class='icon badge-tooltip title-name'><div>${name}</div></span></a>`;
      } else if (key == 'clientId'){
        const obj = _.find(base.clientsList, {id: strategy[key]});
        row.clientName = obj ? obj : null;
        row[key] = strategy[key];
      } else if (key == 'associatedWith'){
        const rates = base.getRatesForThisStrategy(strategy);
        const obj = _.find(rates, {id: strategy[key]});
        row.associated = obj ? obj : null;
      } else if (key == 'stateAssociatedWith'){
        const obj = _.find(base.allStateAssociatedData, {id: strategy[key]});
        row.stateAssociated = obj ? obj : null;
      } else if (key == 'sinceYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.sinceYear = obj ? obj : null;
      } else if (key == 'toYear'){
        const obj = _.find(base.years, {id: strategy[key]});
        row.toYear = obj ? obj : null;
      } else if (key == 'roiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.overriden){
          row['roiAmount-class'] = 'input-red';
        }
      } else if (key == 'stateRoiAmount'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
        if (strategy.stateOrverriden){
          row['stateRoiAmount-class'] = 'input-red';
        }
      } else if (key == 'dollarDifference'){
        row[key] = base.numeralService.format('$0,0', strategy[key]);
      } else if (key == 'percentageDifference'){
        row[key] = strategy[key] + '%';
      } else {
        row[key] = strategy[key];
      }
    });
    row.strategyType = this.getStrategy(strategy).type;
    row.recurring = strategy.recurring;
    row.actions = '';
    let postString = '';
    if (strategy.recurring){
      postString += `<span class='badge-tooltip'><a class='action' data-action='toggle-recurring'><span class="recurring-badge text-center">R</span><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Task is marked recurring</span></a></span>`;
    } else {
      postString += `<span class='badge-tooltip'><a class='action' data-action='toggle-recurring'><span class="non-recurring-badge text-center">R</span></a></span>`;
    }
    if (strategy.taskId){
      postString += `<span class='badge-tooltip'><a class='action' data-action='task'><span class="task-badge text-center">T</span><span class='bottomTooltiptext tpActionTooltip' style="min-width: 100px !important;max-width: 125px !important;">Click to go to the associated task</span></a></span>`;
    }
    if (strategy.notes){
      postString += `<a class='action comment-badge' data-action='notes'><i class="material-icons strategy-action-icon mdl-badge last-activity" data-badge=''>short_text</i></a>`;
    } else {
      postString += `<a class='action' data-action='notes'><i class="material-icons strategy-action-icon">short_text</i></a>`;
    }
    postString += `<a class='action' data-action='edit'><i class="material-icons strategy-action-icon">mode_edit</i></a>`;
    postString += `<a class='action' data-action='delete'><i class="material-icons strategy-action-icon delete">delete</i></a>`;
    row.actions = postString;
    return row;
  }

  showTaskSinglePage(strategyRow) {
    const strategy = _.find(this.clientTaxPlan.strategies, {strategyId: strategyRow.strategyId});
    if (strategy && strategy.locked){
      this.showPurchaseMessage();
    } else if (strategyRow.taskId){
      const url = this._router.url.split('?')[0];
      this.stateService.addState(new State('TAX_STRATEGY', url, null, null, null));
      this._router.navigate(['clients', this.clientTaxPlan.clientId, 'task', strategyRow.taskId, 'singlePage']);
    }
  }
  showStrategy(strategy) {
    const strategyData = _.find(this.clientTaxPlan.strategies, {strategyId: strategy.strategyId});
    if (strategyData && !strategyData.locked){
      this.switchBoard.onDisplayFloatingWindow.next({
        title: 'Strategy Info',
        url: ['tax-planning', 'taxStrategies', strategy.strategyId],
      });
    } else if (strategyData && strategyData.locked){
      this.showPurchaseMessage();
    }
  }

  toggleRecurringForStrategyLine($event){
    const strategyLine = {
      id: $event.id,
      associatedWith: ($event.associated) ? $event.associated.id : null,
      overriden: ($event.overriden) ? $event.overriden : false,
      stateAssociatedWith: $event.stateAssociated ? $event.stateAssociated.id : null,
      stateOrverriden: ($event.stateOrverriden) ? $event.stateOrverriden : false,
      amount: $event.amount,
      actualAmount: $event.actualAmount,
      roiAmount: $event.roiAmount,
      stateRoiAmount: $event.stateRoiAmount,
      clientId: $event.clientId,
      goalDate: $event.goalDate,
      executionDate: $event.executionDate,
      strategyId: $event.strategyId,
      sinceYear: $event.sinceYear ? $event.sinceYear.id : 0,
      toYear: $event.toYear ? $event.toYear.id : 0,
      recurring: !$event.recurring,
      taskId: $event.taskId,
      parentClientId: this.clientUserId,
      notes: $event.notes
    };
    this.updateStrategyLine(strategyLine);
  }

  getTaxStrategyChecklist(strategyLine){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.strategyLineChecklist(this.org, this.user.id, this.clientTaxPlan.id, strategyLine.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.popupChecklistObj = response;
        this.reveal.checklist = true;
        if (response){
          this.popupChecklistObj.strategyId = strategyLine.strategyId;
          setTimeout(() => {
            this.initialiseChecklistSorting();
          });
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to load checklist');
      });
  }

  showStrategyNotesPopup($event){
    this.reveal.strategyNotes = true;
    const strategy = _.find(this.allTaxStrategies, {id: $event.strategyId});
    this.currentNotesStrategy = {
      id: $event.id,
      strategyName: strategy.name,
      notes: $event.notes
    };
  }

  updateNotesForStrategy(){
    const strategyLine = _.find(this.clientTaxPlan.strategies, {id: this.currentNotesStrategy.id});
    strategyLine.notes = this.currentNotesStrategy.notes;
    this.updateClientStrategy();
    this.reveal.strategyNotes = false;
  }

  sortByColumn($event){
    this.strategySort[$event.column] = $event.order;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, this.strategyFilterYear, $event.column, $event.order, this.protectedView)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.dataLoaded = true;
          this.clientTaxPlan = response;
          this.buildTableData(response.strategies || [], true);
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to sort.');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  optionSelected($event){
    const base = this;
    const strategyLine: any = {
      id: $event.row.id,
      associatedWith: $event.row.associated ? $event.row.associated.id : null,
      overriden: ($event.row.overriden) ? $event.row.overriden : false,
      stateAssociatedWith: $event.row.stateAssociated ? $event.row.stateAssociated.id : null,
      stateOrverriden: ($event.row.stateOrverriden) ? $event.row.stateOrverriden : false,
      amount: $event.row.amount,
      actualAmount: $event.row.actualAmount,
      roiAmount: $event.row.roiAmount,
      stateRoiAmount: $event.row.stateRoiAmount,
      clientId: $event.row.clientId,
      goalDate: $event.row.goalDate,
      executionDate: $event.row.executionDate,
      strategyId: $event.row.strategyId,
      sinceYear: $event.row.sinceYear ? $event.row.sinceYear.id : 0,
      toYear: $event.row.toYear ? $event.row.toYear.id : 0,
      recurring: $event.row.recurring,
      taskId: $event.row.taskId,
      parentClientId: this.clientUserId,
      notes: $event.row.notes
    };
    if ($event.column == 'associated'){
      strategyLine.associatedWith = $event.entry.id;
      this.calculateResultAmount(strategyLine);
    } else if ($event.column == 'stateAssociated') {
      strategyLine.stateAssociatedWith = $event.entry.id;
      this.calculateStateResultAmount(strategyLine);
    } else if ($event.column == 'clientName'){
      strategyLine.clientId = $event.entry.id;
      strategyLine.relatedPartyName = $event.entry.name;
    } else if ($event.column == 'sinceYear'){
      strategyLine.sinceYear = $event.entry.id;
    } else if ($event.column == 'toYear'){
      if ($event.entry.id < strategyLine.sinceYear){
        this.toastService.pop(TOAST_TYPE.error, 'You can\'t have the end year before the start year');
        const rows = this.tableData.rows || [];
        _.each(rows, function(row){
          if (row.id == $event.row.id){
            const oldStrategyLine = _.find(base.clientTaxPlan.strategies, {id: $event.row.id});
            const obj = _.find(base.years, {id: oldStrategyLine.toYear});
            row.toYear = obj ? obj : null;
          }
        });
        this.tableData = {...this.tableData, rows};
        return;
      } else{
        strategyLine.toYear = $event.entry.id;
      }
    }
    this.setRelatedPartyName(strategyLine);
    this.updateStrategyLine(strategyLine);
  }

  setClient($event){
    this.newStrategy.clientId = $event.id;
    const client = _.find(this.clientsList, {id: $event.id});
    if (client && client.type == 'Other'){
      this.filteredStrategies = _.cloneDeep(this.allTaxStrategies);
    } else if (client && client.type == '1040'){
      this.filteredStrategies = _.filter(this.allTaxStrategies, function(strategy){
        return strategy.applicableTo == 'Individual' || strategy.applicableTo == 'Both';
      });
    } else if (client && client.type != '1040'){
      this.filteredStrategies = _.filter(this.allTaxStrategies, function(strategy){
        return strategy.applicableTo == 'Business' || strategy.applicableTo == 'Both';
      });
    }
  }

  setType($event){
    this.newStrategy.type = $event.id;
  }

  setStrategy($event){
    this.newStrategy.strategyId = $event.id;
    this.newStrategy.locked = $event.locked;
    if ($event.associatedWith){
      this.newStrategy.associatedWith = $event.associatedWith;
      this.defaultStrategyId = $event.associatedWith;
    } else {
      this.defaultStrategyId = '';
    }
    this.newStrategy.recurring = $event.recurring == 'Yearly';
    this.calculateResultAmount(this.newStrategy);
  }

  setAssociatedWith($event, type){
    if (type == 'federal') {
      this.newStrategy.associatedWith = $event.id;
      this.calculateResultAmount(this.newStrategy);
    } else if (type == 'state') {
      this.newStrategy.stateAssociatedWith = $event.id;
      this.calculateStateResultAmount(this.newStrategy);
    }
  }

  setRelatedPartyName(strategyLine){
    const relatedParty = _.find(this.client.relatedParties, {id: strategyLine.clientId});
    strategyLine.relatedPartyName = relatedParty ? relatedParty.name : '';
  }

  saveNewStrategy(){
    if (this.newStrategy.strategyId && this.newStrategy.clientId && this.newStrategy.sinceYear){
      this.newStrategy.sinceYear = (typeof this.newStrategy.sinceYear === 'string') ? this.newStrategy.sinceYear.trim() : this.newStrategy.sinceYear;
      this.newStrategy.toYear = (typeof this.newStrategy.toYear === 'string') ? this.newStrategy.toYear.trim() : this.newStrategy.toYear;
      if (isNaN(this.newStrategy.sinceYear) || (this.newStrategy.toYear && isNaN(this.newStrategy.toYear))) {
        this.toastService.pop(TOAST_TYPE.error, 'Year should be in YYYY format');
      } else if (!_.inRange(this.newStrategy.sinceYear, 2000, 2099) || (this.newStrategy.toYear && !_.inRange(this.newStrategy.toYear, 2000, 2099))) {
        this.toastService.pop(TOAST_TYPE.error, 'Year should be in YYYY format');
      }else {
        this.newStrategy.action = this.editMode ? 'update' : 'create';
        this.newStrategy.parentClientId = this.clientUserId;
        this.setRelatedPartyName(this.newStrategy);
        this.loadingService.triggerLoadingEvent(true);
        this.taxPlanningService.addUpdateTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, this.newStrategy)
          .subscribe({
            next: (response) => {
              this.loadingService.triggerLoadingEvent(false);
              this.newStrategy = {};
              this.reveal.addStrategy = false;
              setTimeout(() => {
                this.getClientTaxPlan();
              });
            }, error: (error) => {
              this.loadingService.triggerLoadingEvent(false);
              const failedMessage = (this.editMode) ? 'Failed to update strategy.' : 'Failed to add strategy.';
              const message = error.message ? error.message : failedMessage;
              try {
                this.toastService.pop(TOAST_TYPE.error, message);
              } catch (e) {
                this.toastService.pop(TOAST_TYPE.error, message);
              }
            }
          });
      }
    } else if (!this.newStrategy.strategyId){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Tax strategy');
    } else if (!this.newStrategy.clientId){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Payor');
    } else if (!this.newStrategy.sinceYear){
      this.toastService.pop(TOAST_TYPE.error, 'Please select Start Year');
    }
  }

  updateStrategyLine(strategyLine){
    this.loadingService.triggerLoadingEvent(true);
    strategyLine.roiAmount = this.numeralService.getNumberValue(strategyLine.roiAmount);
    strategyLine.stateRoiAmount = this.numeralService.getNumberValue(strategyLine.stateRoiAmount);
    strategyLine.action = 'update';
    this.taxPlanningService.addUpdateTaxStrategyLine(this.org, this.user.id, this.taxStrategyId, strategyLine)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.getClientTaxPlanWithNewData();
        const rows = this.tableData.rows || [];
        const updatedRow = this.createTableRow(response);
        const rowIndex = _.findIndex(rows, {id: strategyLine.id});
        rows[rowIndex] = updatedRow;
        const strategyIndex = _.findIndex(this.clientTaxPlan.strategies, {id: strategyLine.id});
        this.clientTaxPlan.strategies[strategyIndex] = response;
        this.tableData = {...this.tableData, rows};
        this.toastService.pop(TOAST_TYPE.success, 'Strategy updated successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to update strategy');
      });
  }

  deleteScenario(scenario){
    const taxYear = Number(scenario.taxYear || this.clientTaxPlan?.taxYear || this.planYearFilter)
      || new Date().getFullYear();
    this.basicPlanLimits.get(this.org, this.user.id, taxYear, this.clientUserId, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: entitlement => {
          this.basicRestrictionsActive = entitlement.basicRestrictionsActive;
          if (entitlement.canDelete) {
            this.performDeleteScenario(scenario);
            return;
          }
          this.actions = this.actions.filter(action => action.name !== 'Delete Plan');
          this.toastService.pop(TOAST_TYPE.warning,
            'Plans created under the Basic subscription cannot be deleted. Please chat with Support through the Hub for corrections.');
        },
        error: () => {
          this.basicRestrictionsActive = true;
          this.actions = this.actions.filter(action => action.name !== 'Delete Plan');
          this.toastService.pop(TOAST_TYPE.error, 'Failed to verify plan deletion access');
        }
      });
  }

  private performDeleteScenario(scenario){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.deleteClientTaxPlan(this.org, this.user.id, scenario.planId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Plan deleted successfully');
        const scenarioIndex = _.findIndex(this.scenarios, {id: scenario.planId});
        this.scenarios.splice(scenarioIndex, 1);
        this.scenarios = [...this.scenarios];
        if (this.scenarios.length > 0){
          this.defaultScenarioId = this.scenarios[0].id;
          this.openStrategy(this.scenarios[0]);
        } else {
          this._router.navigate(['tax-planning', 'list']);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to delete plan');
      });
  }

  switchPage(view){
    if (this.showClientInfo && view != 'default') {
      this.toastService.pop(TOAST_TYPE.warning, 'Please select a plan');
    } else if (!this.showClientInfo && view == 'default') {
      this._router.navigate(['tax-planning', 'clients', this.clientUserId, 'overview']);
    } else {
      // Auto-save tax estimates when leaving that tab
      if (this.currentView === 'tax_estimates' && view !== 'tax_estimates' && this.taxEstimatesComponent) {
        this.taxEstimatesComponent.autoSave();
      }
      this.currentView = view;
      this.hasROIData = false;
      this.checkPlanPaymentStatus();
      if (view == 'roi_page'){
        this.roiView = 'Category';
        this.roiFilterYear = this.planYearFilter;
        this.getDefaultYearForROI();
        this.getTaxPlanningSummary(this.roiView, this.roiFilterYear);
      }
      if (view === 'roi_dashboard'){
        this.roiGraphFilterYear = this.planYearFilter;
      }

      jQuery('#a-default').attr('aria-selected', 'false');
      jQuery('#a-client_plan').attr('aria-selected', 'false');
      jQuery('#a-roi_page').attr('aria-selected', 'false');
      jQuery('#a-roi_dashboard').attr('aria-selected', 'false');
      jQuery('#a-roi_presentation').attr('aria-selected', 'false');
      jQuery('#a-tax_estimates').attr('aria-selected', 'false');
      jQuery('#a-cashflow_timeline').attr('aria-selected', 'false');
      jQuery('#a-' + view).attr('aria-selected', 'true');
    }
  }
  /**
   * Make sure we are on the client_plan tab
   * Ensure Fees section is shown
   * Wait for Angular to render the component and populate @ViewChild, then open modal
   */
  onNavigateToAddFees() {
    if (this.currentView !== 'client_plan') {
      this.switchPage('client_plan');
    }
    
    if (!this.showCostLines) {
      this.showCostLines = true;
    }
    
    setTimeout(() => {
      if (this.feeLinesComponent) {
        this.feeLinesComponent.addNewFeeLine();
      }
    }, 200);
  }

  checkPlanPaymentStatus() {
    const paidPlans = this.taxPlanningService.getPaidPlans();
    if (this.currentPlan) {
      if (this.currentPlan.toLowerCase().includes("pay-per-tax-plan") && paidPlans && paidPlans.length > 0) {
        this.isPaidPlan = _.includes(paidPlans, this.taxStrategyId);
      } else {
        this.isPaidPlan = true;
      }
    }
  }

  getTaxPlanningSummary(view?, filter?, noOfYears?){
    this.loadingService.triggerLoadingEvent(true);
    const taxPlanId = (this.clientTaxPlan && this.clientTaxPlan.id) ? this.clientTaxPlan.id : this.taxStrategyId;
    this.taxPlanningService.getTaxPlanningSummary(this.org, this.user.id, taxPlanId, view, filter, noOfYears,this.isMerged)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.hasROIData = true;
        this.roiData = response;
        if (noOfYears) {
          this.roiData.customizedYear = noOfYears;
        }
        this.hasActualAmount = Array.isArray(this.roiData.categories) &&
        this.roiData.categories.some(cat => cat.totalInfo?.actualAmount > 0);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  initialiseChecklistSorting() {
    const base = this;
    setTimeout(() => {
      jQuery('.sortableChecklist').sortable({
        placeholder: 'ui-checklist-highlight',
        stop(event, ui) {
          const result = [];
          const itemsMarkup = jQuery(this).children();
          _.each(itemsMarkup, function(markup) {
            const id = markup.children[0].innerText;
            result.push(id);
          });
          const tempArray = [];
          _.each(result, function(id){
            tempArray.push(_.find(base.popupChecklistObj.checklists, {id}));
          });
          base.popupChecklistObj.checklists = tempArray;
        }
      });
      jQuery('.sortableChecklist').disableSelection();
    });
  }

  updateChecklist($event, value){
    value.editingName  = false;
    value.name = value.tempName;
  }

  removeCheckListValue(checklist, index){
    checklist.splice(index, 1);
  }

  stopEditingName($event, value){
    value.editingName = false;
    value.tempName = value.name;
  }

  editChecklist($event, checklist, index, value){
    _.each(checklist, function(checklistItem){
      checklistItem.editingName = false;
    });
    checklist[index].editingName = true;
    checklist[index].tempName = checklist[index].name;
  }

  saveChecklist(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.saveChecklist(this.org, this.user.id, this.popupChecklistObj.strategyId, this.popupChecklistObj)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Checklist updated successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to update Checklist');
      });
  }

  setView($event){
    this.roiView = $event.name;
    this.getTaxPlanningSummary(this.roiView, this.roiFilterYear);
  }

  selectYear($event, key){
    this.newStrategy[key] = $event.entry.id;
  }

  filterROIPage($event){
    if (this.roiFilterYear != $event.id) {
      this.roiFilterYear = $event.id;
      this.roiDefaultYear = (this.currentRoiDefaultYear == $event.id) ? true : false;
      this.getTaxPlanningSummary(this.roiView, this.roiFilterYear);
    }
  }

  exportToExcel(page){
    if (page == 'roi_page') {
      const urlString = (this.currentEnvironment.production) ? 'https://services.taxplaniq.com' : 'https://dev-services.taxplaniq.com';
      const data: any = {};
      data.url = urlString + '/TaxPlanningServices/orgs/' + this.org + '/users/' + this.user.id + '/clientstrategy/' + this.clientTaxPlan.id + '/summary?groupby=' + encodeURIComponent(this.roiView) + '&filter=' + this.roiFilterYear;
      data.fileName = `Tax Planning - ${this.clientTaxPlan.userName}.xls`;
      data.reportName = 'ROI';
      data.org = this.org;
      data.orgName = this.orgName;
      data.orgLogo = this.orgLogo;
      data.taxYear = this.roiFilterYear;
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.exportROIExcel(this.org, this.user.id, data)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Tax Planning - ${this.clientTaxPlan.userName}.xls`;
          link.click();
          this.taxPlanningService.logReportDownload(this.org, this.user.id, {
            taxPlan: this.clientTaxPlan,
            format: 'excel',
            status: 'success',
          }).subscribe();
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Into Excel');
          this.taxPlanningService.logReportDownload(this.org, this.user.id, {
            taxPlan: this.clientTaxPlan,
            format: 'excel',
            status: 'failure',
            errorMessage: error?.message || 'Unknown error exporting report Excel',
          }).subscribe();
        });
    }
  }

  exportToPDF(page){
    if (page == 'roi_page'){
      const pdfReq = this.getPDFRequestObject();
      const url = '/TaxPlanningServices/orgs/' + this.org + '/users/' + this.user.id + '/export/custom-pdf';
      this.loadingService.triggerLoadingEvent(true);
      this.exportService.exportReportIntoFile(url, pdfReq)
        .subscribe(data => {
          this.loadingService.triggerLoadingEvent(false);
          const blob = new Blob([data], {type: 'application/pdf'});
          const link = jQuery('<a></a>');
          link[0].href = URL.createObjectURL(blob);
          link[0].download = `Tax Planning - ${this.clientTaxPlan.userName}.pdf`;
          link[0].click();
          this.taxPlanningService.logReportDownload(this.org, this.user.id, {
            taxPlan: this.clientTaxPlan,
            format: 'pdf',
            status: 'success',
          }).subscribe();
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Into PDF');
          this.taxPlanningService.logReportDownload(this.org, this.user.id, {
            taxPlan: this.clientTaxPlan,
            format: 'pdf',
            status: 'failure',
            errorMessage: error?.message || 'Unknown error exporting report PDF',
          }).subscribe();
        });
    }
  }

  getPDFRequestObject(){
    const htmlTemps = [];
    let roiInfoHtml = this.getUserRoiForPlan();
    roiInfoHtml = this.getReplacedSpacialCharactersString(roiInfoHtml);
    htmlTemps.push(roiInfoHtml);
    const style = this.getHtmlStyleString();
    const pdfReq = {
      version: '1.1',
      htmlTemplates: [style + htmlTemps],
      footer: moment(new Date()).format('MMMM DD, YYYY HH:mm a')
    };
    return pdfReq;
  }

  getHtmlStyleString() {
    let styleString = '';
    const styleHtml = jQuery('style').clone();
    if (styleHtml && styleHtml.length >= 2){
      for (let i = 1; i < styleHtml.length; i++){
        const temp = styleHtml[i].outerHTML;
      }
    }
    return styleString;
  }

  getReplacedSpacialCharactersString(inputString) {
    if (inputString) {
      inputString = inputString.replaceAll("<br>", "<br/>");
      inputString = inputString.replaceAll('“', '"');
      inputString = inputString.replaceAll('”', '"');
      inputString = inputString.replaceAll('‘', "'");
      inputString = inputString.replaceAll('’', "'");
      inputString = inputString.replace(/(<img("[^"]*"|[^/">])*)>/gi, '$1/>');
    }
    return inputString;
  }
  getUserRoiForPlan() {
    const img = `<img width="20%" height="10%" src="${this.orgLogo}"/>`;
    let html = jQuery('#numeric').clone().html();
    // let html = jQuery('<div>').append(styleString).append(jQuery('#numeric').clone()).html();
    html = html.replace('````', img);
    return html;
  }

  getIntroLetterForPlan() {
    let styleString = '';
    const styleHtml = jQuery('style').clone();
    if (styleHtml && styleHtml.length >= 2){
      for (let i = 1; i < styleHtml.length; i++){
        styleString += styleHtml[i].outerHTML;
      }
    }
    const img = `<img width="100%" src="${this.orgLogo}"/>`;
    let html = jQuery('<div>').append(styleString).append(jQuery('#roi-custom-info').clone()).html();
    html = html.replace('````', img);
    return html;
  }

  getCustomRoiStrategiesInfoForPlan() {
    let styleString = '';
    const styleHtml = jQuery('style').clone();
    if (styleHtml && styleHtml.length >= 2){
      for (let i = 1; i < styleHtml.length; i++){
        styleString += styleHtml[i].outerHTML;
      }
    }
    const html = jQuery('<div>').append(styleString).append(jQuery('#roi-custom-stretegies-info').clone()).html();
    return html;
  }

  removeTempCustomRate(index){
    this.tempCustomTaxRates.splice(index, 1);
  }

  onRateBlur(obj, key){
    obj[key] = obj[key] / 100;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  onRateFocus(obj, key){
    obj[key] = obj[key] * 100;
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  openStrategy(scenario){
    this.taxPlanName = scenario.name;
    this._router.navigate(['tax-planning', 'client', this.clientTaxPlan.clientId, scenario.id, this.planYearFilter, 'client_plan'], {queryParams: {fromCreateOrDuplicatePlan: true}});
  }

  handleAction($event){
    if ($event.name == 'Related Parties'){
      this.switchBoard.onDisplayFloatingWindow.next({
        title: 'Edit Client',
        url: ['tax-planning', 'clients', 'edit', this.clientUserId]
      });
    } else if ($event.name == 'Duplicate Plan'){
      this.duplicatePlanName = this.clientTaxPlan.name;
      this.reveal['duplicate-plan'] = true;
    } else if ($event.name == 'Rename Plan'){
      this.newPlanName = this.clientTaxPlan.name;
      this.reveal['rename-plan'] = true;
    } else if ($event.name == 'Delete Plan'){
      if (this.basicRestrictionsActive) {
        this.toastService.pop(TOAST_TYPE.warning,
          'Plans created under the Basic subscription cannot be deleted. Please chat with Support through the Hub for corrections.');
        return;
      }
      this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure to delete plan?', {
        planId: this.clientTaxPlan.id,
        type: 'taxPlan'
      });
    } else if ($event.name == 'Fees'){
      this.showCostLines = !this.showCostLines;
    } else if ($event.name == 'Rates'){
      this.showRates = !this.showRates;
    } else if ($event.name == 'Send Proposal' || $event.name == 'Engagement Letter' || $event.name == 'Invoice'){
      this.reveal.extraOptions = true;
    }
  }

  private loadPlanDeletionEntitlement(): void {
    const taxYear = Number(this.planYearFilter) || new Date().getFullYear();
    this.basicPlanLimits.get(this.org, this.user.id, taxYear, this.clientUserId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: entitlement => {
          this.basicRestrictionsActive = entitlement.basicRestrictionsActive;
          if (this.basicRestrictionsActive) {
            this.actions = this.actions.filter(action => action.name !== 'Delete Plan');
          } else if (!this.actions.some(action => action.name === 'Delete Plan')) {
            this.actions.splice(3, 0, {name: 'Delete Plan'});
          }
        },
        error: () => {
          this.basicRestrictionsActive = true;
          this.actions = this.actions.filter(action => action.name !== 'Delete Plan');
        }
      });
  }

  toggleCostLines(){
    this.showCostLines = !this.showCostLines;
    // set FALSE to remaiing fields
    this.showCashflow = false;
    this.showRates = false;
    this.showNotes = false;
  }

  toggleCashflow(){
    this.showCashflow = !this.showCashflow;
    // set FALSE to remaiing fields
    this.showCostLines = false;
    this.showRates = false;
    this.showNotes = false;
  }

  toggleRates(){
    this.showRates = !this.showRates;
    // set FALSE to remaiing fields
    this.showCostLines = false;
    this.showCashflow = false;
    this.showNotes = false;
  }

  toggleNotes(){
    this.showNotes = !this.showNotes;
    // set FALSE to remaiing fields
    this.showRates = false;
    this.showCostLines = false;
    this.showCashflow = false;
  }

  createDuplicate(){
    if (this.duplicatingPlan) {
      return;
    }
    const obj = {
      action: 'duplicate',
      newName: this.duplicatePlanName,
      CustomerEmail: this.clientUserId
    };
    if (this.validateDuplicatePlanYear()) {
      const taxYear = Number(this.duplicatePlanYear);
      this.duplicatingPlan = true;
      this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientUserId, taxYear)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: confirmation => {
            if (!confirmation) {
              this.duplicatingPlan = false;
              return;
            }
            this.submitDuplicate(obj, taxYear, confirmation);
          },
          error: error => {
            this.duplicatingPlan = false;
            this.toastService.pop(TOAST_TYPE.error,
              this.planCreationGuard.errorMessage(error, 'Failed to verify plan limits'));
          }
        });
    }
  }

  private submitDuplicate(obj: any, taxYear: number, confirmation: PlanCreationConfirmation,
                          countChangeRetryAttempted = false): void {
    const request = {...obj, ...confirmation};
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.duplicatePlan(this.org, this.user.id, this.clientTaxPlan.id, request, taxYear)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          this.loadingService.triggerLoadingEvent(false);
          this.duplicatingPlan = false;
          this.basicPlanLimits.invalidate(this.org, taxYear);
          this.reveal['duplicate-plan'] = false;
          this.toastService.pop(TOAST_TYPE.success, 'Plan duplicated successfully');
          this._router.navigate(['tax-planning', 'client', this.clientUserId, response.strategyId, taxYear, 'client_plan'], {queryParams: {fromCreateOrDuplicatePlan: true}});
        },
        error: error => {
          this.loadingService.triggerLoadingEvent(false);
          if (this.planCreationGuard.shouldRetryCountChange(error, countChangeRetryAttempted)) {
            this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientUserId, taxYear,
              confirmation.creationRequestId)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: refreshed => {
                  if (refreshed) {
                    this.submitDuplicate(obj, taxYear, refreshed, true);
                  } else {
                    this.duplicatingPlan = false;
                  }
                },
                error: refreshError => {
                  this.duplicatingPlan = false;
                  this.toastService.pop(TOAST_TYPE.error,
                    this.planCreationGuard.errorMessage(refreshError, 'Failed to verify plan limits'));
                }
              });
            return;
          }
          this.duplicatingPlan = false;
          this.toastService.pop(TOAST_TYPE.error,
            this.planCreationGuard.errorMessage(error, 'Failed to create duplicate plan'));
        }
      });
  }

  validateDuplicatePlanYear() {
    let validateTrue = true;
    if (!this.duplicatePlanName) {
      validateTrue = false;
      this.toastService.pop(TOAST_TYPE.error, 'Plan name is mandatory');
      return false;
    }
    if (this.duplicatePlanYear) {
      const planYear = parseInt(this.duplicatePlanYear);
      if (planYear < 2010 || planYear > 2050) {
        validateTrue = false;
        this.toastService.pop(TOAST_TYPE.error, 'Please enter in a valid plan year.');
        return false;
      }
    } else {
      validateTrue = false;
      this.toastService.pop(TOAST_TYPE.error, 'Plan year is mandatory');
      return false;
    }
    return validateTrue;
  }

  renamePlan(){
    this.loadingService.triggerLoadingEvent(true);
    const obj = {
      action: 'rename',
      newName: this.newPlanName
    };
    this.taxPlanningService.renamePlan(this.org, this.user.id, this.clientTaxPlan.id, obj)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Plan renamed successfully');
        this.getClientPlans();
        this.clientTaxPlan.name = this.newPlanName;
        this.newPlanName = '';
        this.reveal['rename-plan'] = false;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to rename plan');
      });
  }

  editEntity(entity){
    entity.tempName = entity.name;
    entity.isEditing = true;
  }

  deleteEntity(index){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.deleteEntity(this.org, this.user.id, this.clientUserId, this.entities[index].id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.entities.splice(index, 1);
        this.toastService.pop(TOAST_TYPE.success, 'Entity deleted successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to delete entity');
      });
  }

  updateEntity(entity){
    entity.name = entity.tempName;
    entity.clientId = this.clientUserId;
    entity.isEditing = false;
    if (!entity.id){
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.createEntity(this.org, this.user.id, this.clientUserId, entity)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          entity.isEditing = false;
          entity.id = response.id;
          this.toastService.pop(TOAST_TYPE.success, 'Entity created successfully');
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create entity');
        });
    } else{
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.updateEntity(this.org, this.user.id, this.clientUserId, entity)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Entity updated successfully');
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update entity');
        });
    }
  }

  stopEditingEntity(entity){
    entity.isEditing = false;
  }

  addEntity(){
    this.entities.push({
      id: '',
      name: '',
      tempName: '',
      isEditing: true
    });
  }

  openStrategyDetail(){
    if (this.newStrategy.strategyId){
      this.switchBoard.onDisplayFloatingWindow.next({
        title: 'Strategy Info',
        url: ['tax-planning', 'taxStrategies', this.newStrategy.strategyId],
      });
    }
  }

  toggleAddCustomRate(flag){
    this.showAddCustomRateInPopup = flag;
  }

  appendNewCustomRate(){
    if (this.newCustomRate.name && this.newCustomRate.rate){
      this.newCustomRate.id = uuid();
      this.newCustomRate.formula =  JSON.stringify(this.newCustomRate.formula);
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.addEditCustomRate(Session.getOrg(), this.user.id, this.clientTaxPlan.id, this.newCustomRate).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.newCustomRate.formula =  JSON.parse(this.newCustomRate.formula);
        this.toastService.pop(TOAST_TYPE.success, 'Custom Rate created successfully');
        this.clientTaxPlan.customTaxRates.push(this.newCustomRate);
        // Only expose non-state custom rates to the Federal Associated dropdown
        const parsedCustomRate = _.cloneDeep(this.newCustomRate);
        parsedCustomRate.formula = this.deserializeFormula(parsedCustomRate.formula);
        if (!this.isStateRate(parsedCustomRate)) {
          this.associatedWith = [...this.associatedWith, parsedCustomRate];
          // Also push into strategy-specific associated list so it appears immediately for the selected strategy
          const currentStrategyId = this.newStrategy.strategyId;
          if (currentStrategyId) {
            const existing = this.allAssociatedData[currentStrategyId] || _.cloneDeep(this.associatedWith);
            this.allAssociatedData[currentStrategyId] = _.uniqBy([...existing, parsedCustomRate], 'id');
          }
        }
        this.newStrategy.associatedWith = this.newCustomRate.id;
        this.newCustomRate = {
          id: '',
          name: '',
          rate: 0,
          formula: {
            displayValue: '',
            actualValue: '',
            displayValuesArray: [],
            actualValuesArray: []
          }
        };
        this.showAddCustomRateInPopup = false;
        this.buildAssociatedObject();
        this.buildStateAssociatedObject();
        this.calculateResultAmount(this.newStrategy);
        this.defaultStrategyId = response.id;
        this.tableData = {...this.tableData};
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : 'Failed to create Custom Rate';
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
    } else if (!this.newCustomRate.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter name');
    } else if (!this.newCustomRate.rate) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter rate');
    }
  }

  showStatusWarning(type){
    if (this.userReadOnly) {
      this.toastService.pop(TOAST_TYPE.warning, 'You cannot make edits to the default client plans.');
    } else {
      const base = this;
      this.emptyFields();
      this.reveal.publishtoggle = true;
      if (type === 'unpublish') {
        this.getActiveUnpublishedValues();
      }
    }
  }

  updateStatus(type?){
    if (this.userReadOnly) {
      this.toastService.pop(TOAST_TYPE.warning, 'You cannot make edits to the default client plans.');
    } else {
      const base = this;
      this.emptyFields();
      this.reveal.publishtoggle = true;
      if (type && type === 'unpublish') {
        this.getActiveUnpublishedValues();
      }
    }
  }

  showAdditionalInfo(type){
    if (type == 'notes') {
      this.clientPlanInfoType = 'notes';
    } else if (type == 'disclaimer') {
      this.clientPlanInfoType = 'disclaimer';
    } else if (type == 'report_customization') {
      this.clientPlanInfoType = 'report_customization';
    } 
    this.reveal.planInfo = true;
  }

  showColumnDescriptions(){
    this.reveal.columnDescriptions = true;
  }

  deleteCustomRate(index){
    const rateToDelete = this.clientTaxPlan.customTaxRates[index];
    const usedIn = _.filter(this.clientTaxPlan.strategies, {associatedWith: rateToDelete.id});
    const usedInStateAssociate = _.filter(this.clientTaxPlan.strategies, {stateAssociatedWith: rateToDelete.id});
    if ((usedIn && usedIn.length > 0) || (usedInStateAssociate && usedInStateAssociate.length > 0)) {
      this.toastService.pop(TOAST_TYPE.confirm, 'This rate is being used in this plan. Are you sure to delete?', {
        rateId: rateToDelete.id,
        type: 'customRate'
      });
    } else {
      this.deleteCustomTaxRate(rateToDelete.id);
    }
  }

  deleteCustomTaxRate(customRateId, observer?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.deleteCustomRate(Session.getOrg(), this.user.id, customRateId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Custom rate deleted successfully');
        const deletedRateIndex: any = _.findIndex(this.fixedRatesArray, function(rate) { return rate.id === customRateId; });
        if (deletedRateIndex != -1) {
          this.fixedRatesArray.splice(deletedRateIndex, 1);
        }
        if (observer){
          observer.next(1);
        } else {
          const index = _.findIndex(this.clientTaxPlan.customTaxRates, {id: customRateId});
          if (index != -1) {
            this.clientTaxPlan.customTaxRates.splice(index, 1);
          }
          const associateRateIndex = _.findIndex(this.associatedWith, {id: customRateId});
          if (associateRateIndex != -1) {
            this.associatedWith.splice(associateRateIndex, 1);
            this.buildAssociatedObject();
          }
        }
      }, error => {
        if (observer){
          observer.next(0);
        }
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to delete Custom rate');
      });
  }

  removeCustomRate(rate){
    const base = this;
    const destroyOnResponse = new EventEmitter<number>();
    this.deleteCustomTaxRate(rate.rateId, destroyOnResponse);

    destroyOnResponse.subscribe(status => {
      if (status == 1){
        const associatedIndex = _.findIndex(this.associatedWith, {id: rate.rateId});
        if (associatedIndex != -1){
          this.associatedWith.splice(associatedIndex, 1);
          this.buildAssociatedObject();
        }
        const index = _.findIndex(this.clientTaxPlan.customTaxRates, {id: rate.rateId});
        this.clientTaxPlan.customTaxRates.splice(index, 1);
        _.each(this.clientTaxPlan.strategies, function(strategy){
          if (strategy.associatedWith == rate.rateId){
            strategy.associatedWith = null;
            base.calculateResultAmount(strategy);
          }
          if (strategy.stateAssociatedWith == rate.rateId){
            strategy.stateAssociatedWith = null;
            base.calculateStateResultAmount(strategy);
          }
        });
        this.tableData = {...this.tableData};
        this.updateClientStrategy();
      }
      destroyOnResponse.complete();
    });
  }

  showPurchaseMessage(){
    this.toastService.pop(TOAST_TYPE.info, 'To see more attorney client collaborated strategies, please purchase the full version of the software');
  }

  addNewClient(){
    this.switchBoard.onDisplayFloatingWindow.next({
      title: 'Add New Client',
      url: ['tax-planning', 'clients', 'add']
    });
  }

  showRatesInfo(){
    window.open('https://taxfoundation.org/data/all/federal/2026-tax-brackets/');
  }

  publishStrategy(type) {
    const data = [];
    if (this.publishStrategyType) {
      data.push('Strategy');
    }
    if (this.publishCategoryType) {
      data.push('Category');
    }
    if (this.publishRelatedPartyType) {
      data.push('Related Party');
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.publishStrategy(Session.getOrg(), this.user.id, this.taxStrategyId, type, data)
      .subscribe(response => {
        this.getClientTaxPlanWithNewData();
        this.hideReveal('publishtoggle');
        this.toastService.pop(TOAST_TYPE.success, 'Plan published successfully');
      }, error => {
        this.handleError(error);
      });
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    error = JSON.parse(error);
    const message = error.message ? error.message : `Failed To Perform Operation`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  unpublishStrategy(type) {
    const data = [];
    if (this.unpublishValues.strategy) {
      data.push('Strategy');
    }
    if (this.unpublishValues.category) {
      data.push('Category');
    }
    if (this.unpublishValues.relatedParty) {
      data.push('Related Party');
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.publishStrategy(Session.getOrg(), this.user.id, this.taxStrategyId, type, data)
      .subscribe(response => {
        this.getClientTaxPlanWithNewData();
        this.hideReveal('publishtoggle');
        const message = (type === 'publish') ? 'Views Updated Successfully' : 'Plan Unpublished Successfully';
        this.toastService.pop(TOAST_TYPE.success, message);
      }, error => {
        this.handleError(error);
      });
  }

  getActiveUnpublishedValues() {
    const base = this;
    if (this.clientTaxPlan.views && this.clientTaxPlan.views.length > 0) {
      _.each(this.clientTaxPlan.views, function(viewName){
        if (viewName === 'Strategy') {
          base.unpublishValues.strategy = true;
        } else if (viewName === 'Category') {
          base.unpublishValues.category = true;
        } else if (viewName === 'Related Party') {
          base.unpublishValues.relatedParty = true;
        }
      });
    }
  }

  getClientTaxPlanWithNewData(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user.id, this.taxStrategyId, null, null, null, this.protectedView)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.clientTaxPlan.status = response.status;
          this.clientTaxPlan.views = (response.views) ? response.views : [];
          this.clientTaxPlan.totalAmount = (response.totalAmount) ? response.totalAmount : 0;
          this.clientTaxPlan.totalStateTaxSavings = (response.totalStateTaxSavings) ? response.totalStateTaxSavings : 0;
          this.clientTaxPlan.totalPlanAmount = (response.totalPlanAmount) ? response.totalPlanAmount : 0;
          this.clientTaxPlan.actualTaxSavingsTotal = (response.actualTaxSavingsTotal) ? response.actualTaxSavingsTotal : 0;
          this.buildTableData(response.strategies || []);
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to load tax plan');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  emptyFields() {
    this.publishStrategyType = false;
    this.publishCategoryType = false;
    this.publishRelatedPartyType = false;
  }

  openFormulaCalculator(tempCustomRate?, index?) {
    if (tempCustomRate) {
      this.tempCustomRateObject = tempCustomRate;
    }
    if (index != -1) {
      this.indexOfTempCustomRateObject = index;
    }
    this.reveal.fromulaCalculator = true;
  }

  emptyFormulaFields() {
    this.finalFormula = {
      displayValue: '',
      actualValue: '',
      displayValuesArray: [],
      actualValuesArray: []
    };
    this.sampleCalculatedTaxValue = '';
    this.formulaRatesNamesArray = [];
    this.formulaRatesIdsArray = [];
  }

  showEditForCustomRate(rateObj) {
    const rate = _.cloneDeep(rateObj);
    if (rate && !rate.formula.displayValue) {
      rate.formula.displayValue = rate.rate;
      rate.formula.actualValue = rate.rate;
      rate.formula.displayValuesArray = (rate.formula.displayValuesArray) ? rate.formula.displayValuesArray : [];
      rate.formula.actualValuesArray = (rate.formula.actualValuesArray) ? rate.formula.actualValuesArray : [];
      rate.formula.displayValuesArray.push(rate.rate);
      rate.formula.actualValuesArray.push(rate.rate);
    }
    setTimeout(() => {
      this.openFormulaCalculator(rate, -1);
    });
  }

  triggerRecalcAndUpdatePlan(){
    this.triggerRecalculation();
    this.updateClientStrategy();
  }

  refreshTableData(){
    this.tableData = {...this.tableData};
  }

  createCustomRate(customRate, index){
    if (customRate.name && customRate.rate){
      this.loadingService.triggerLoadingEvent(true);
      customRate.id = uuid();
      customRate.formula =  JSON.stringify(customRate.formula);
      this.taxPlanningService.addEditCustomRate(Session.getOrg(), this.user.id, this.clientTaxPlan.id, customRate).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        customRate.formula =  JSON.parse(customRate.formula);
        this.toastService.pop(TOAST_TYPE.success, 'Custom rate created successfully');
        this.clientTaxPlan.customTaxRates.push(customRate);
        this.tempCustomTaxRates.splice(index, 1);
        this.associatedWith.push(customRate);
        _.each(this.allAssociatedData, function(associatedFields, strategyId){
          associatedFields.push(customRate);
        });
        this.buildAssociatedObject();
        this.refreshTableData();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : 'Failed to create Custom Rate';
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
    } else if (!customRate.name){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter custom tax rate name');
    } else if (!customRate.rate){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter custom tax rate');
    }
  }

  updateCustomTaxRate(key, isFromCustomRate){
    const base = this;
    let editedRate: any;
    if (isFromCustomRate) {
      editedRate = _.cloneDeep(this.clientTaxPlan.customTaxRates[key]);
      editedRate.rate = this.temp[key];
      editedRate.name = this.tempNames[key];
      editedRate.formula =  JSON.stringify(editedRate.formula);
    } else {
      editedRate = key;
    }

    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateCustomRate(Session.getOrg(), this.user.id, this.clientTaxPlan.id, editedRate).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      if (isFromCustomRate) {
        this.propageCustomRateChange(editedRate);
        this.triggerRecalcAndUpdatePlan();
        this.toggleField(key, false);
      }
    }, error => {
      this.revertValue(key);
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : 'Failed to update Custom Rate';
      try {
        this.toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  triggerCloseEditCustomRate(customeRate) {
    const taxPlanIndex: any = _.findIndex(this.clientTaxPlan.customTaxRates, function(rate) { return rate.id === customeRate.id; });
    if (taxPlanIndex != -1) {
      this.toggleField(taxPlanIndex, false);
    }
  }

  reCalculateCustomRates()  {
    const base = this;
    _.each(base.clientTaxPlan.customTaxRates, function(customRate){
      const updatedCustomRate = {...customRate};
      if (updatedCustomRate.formula) {
        const formula = updatedCustomRate.formula;
        updatedCustomRate.rate = ((formula.actualValue) ? evaluate(base.getRateFormula(formula.actualValue)) : updatedCustomRate.rate) || 0;
        const index = _.findIndex(base.clientTaxPlan.customTaxRates, {id: customRate.id});
        base.clientTaxPlan.customTaxRates[index] = _.cloneDeep(updatedCustomRate);
        updatedCustomRate.formula = JSON.stringify(updatedCustomRate.formula);
        base.updateCustomTaxRate(updatedCustomRate, false);
        base.propageCustomRateChange(updatedCustomRate);
      }
    });
    this.triggerRecalcAndUpdatePlan();
  }

  triggerCloseAddCustomRateInStrategyPage(rate) {
    this.defaultStrategyId = rate.id;
    this.newStrategy.associatedWith = rate.id;
    this.calculateResultAmount(this.newStrategy);
    this.newCustomRate = {
      id: '',
      name: '',
      rate: 0,
      formula: {
        displayValue: '',
        actualValue: '',
        displayValuesArray: [],
        actualValuesArray: []
      }
    };
    this.showAddCustomRateInPopup = false;
  }

  setPlanYear($event) {
    this.planYearFilter = $event.id;
    this.fillROIYears();
    this.getClientPlans(true);
  }

  closePeriodOfPlan() {
    if (this.userReadOnly) {
      this.toastService.pop(TOAST_TYPE.warning, 'You cannot make edits to the default client plans.');
    } else {
      this.reveal.closePeriod = true;
    }
  }

  freezeOrUnfreezePlan(type, planName, closePeriod?) {
    if (closePeriod && this.closingPeriodPlan) {
      return false;
    }
    if (this.userReadOnly) {
      this.toastService.pop(TOAST_TYPE.warning, 'You cannot make edits to the default client plans.');
      return false;
    } else if (closePeriod && !this.closeYearPlanName) {
      this.showPlanNameValidationMessage = true;
      return false;
    } else {
      this.showPlanNameValidationMessage = false;
    }
    if (closePeriod) {
      const targetTaxYear = Number(this.planYearFilter) + 1;
      this.closingPeriodPlan = true;
      this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientUserId, targetTaxYear)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: confirmation => {
            if (confirmation) {
              this.performFreezeOrUnfreeze(type, planName, false, targetTaxYear, confirmation);
            } else {
              this.closingPeriodPlan = false;
            }
          },
          error: error => {
            this.closingPeriodPlan = false;
            this.toastService.pop(TOAST_TYPE.error,
              this.planCreationGuard.errorMessage(error, 'Failed to verify plan limits'));
          }
        });
      return;
    }
    this.performFreezeOrUnfreeze(type, planName, true);
  }

  private performFreezeOrUnfreeze(type, planName, archiveOnly: boolean, targetTaxYear?: number,
                                  confirmation?: PlanCreationConfirmation,
                                  countChangeRetryAttempted = false) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.archiveOrUnarchivePlan(
      this.org, this.user.id, this.clientTaxPlan.id, type, archiveOnly, planName,
      confirmation?.creationRequestId, confirmation?.confirmedCreditNumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          this.loadingService.triggerLoadingEvent(false);
          if (targetTaxYear) {
            this.closingPeriodPlan = false;
            this.basicPlanLimits.invalidate(this.org, targetTaxYear);
          }
          this.hideReveal('closePeriod');
          if (type === 'archive') {
            this.toastService.pop(TOAST_TYPE.success, 'Plan archived successfully');
            this.freezPlan = true;
            this.formRowsDataForFreezingPlan();
          } else {
            this.toastService.pop(TOAST_TYPE.success, 'Plan Unarchived successfully');
            this.freezPlan = false;
          }
          if (response.newStrategyId) {
            this._router.navigate(['tax-planning', 'client', this.clientUserId, response.newStrategyId, targetTaxYear, 'client_plan'], {queryParams: {fromCreateOrDuplicatePlan: true}});
          }
        },
        error: error => {
          this.loadingService.triggerLoadingEvent(false);
          if (confirmation && targetTaxYear
            && this.planCreationGuard.shouldRetryCountChange(error, countChangeRetryAttempted)) {
            this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientUserId, targetTaxYear,
              confirmation.creationRequestId)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: refreshed => {
                  if (refreshed) {
                    this.performFreezeOrUnfreeze(type, planName, archiveOnly, targetTaxYear, refreshed, true);
                  } else {
                    this.closingPeriodPlan = false;
                  }
                },
                error: refreshError => {
                  this.closingPeriodPlan = false;
                  this.toastService.pop(TOAST_TYPE.error,
                    this.planCreationGuard.errorMessage(refreshError, 'Failed to verify plan limits'));
                }
              });
            return;
          }
          if (targetTaxYear) {
            this.closingPeriodPlan = false;
          }
          if (type === 'archive') {
            this.toastService.pop(TOAST_TYPE.error,
              this.planCreationGuard.errorMessage(error, 'Failed to archive Plan'));
          } else {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to unarchive Plan');
          }
        }
      });
  }

  formRowsDataForFreezingPlan() {
    const strategies = _.cloneDeep(this.clientTaxPlan.strategies);
    const base = this;
    const tooltipClass = base.getTooltipHtmlClass();
    _.each(strategies, function(strategy){
      strategy.strategyName = strategy.strategyName || '';
      const obj = _.find(base.clientsList, {id: strategy.clientId});
      strategy.clientName = obj ? obj.name : null;
      const rates = base.getRatesForThisStrategy(strategy);
      const ascObj = _.find(rates, {id: strategy.associatedWith});
      const stateAscObj = _.find(base.allStateAssociatedData, {id: strategy.stateAssociatedWith});
      strategy.associated = ascObj ? ascObj.name : null;
      strategy.stateAssociated = stateAscObj ? stateAscObj.name : null;
      const sinceYearObj = _.find(base.years, {id: strategy.sinceYear});
      strategy.sinceYear = sinceYearObj ? sinceYearObj.name : null;
      const toYearObj = _.find(base.years, {id: strategy.toYear});
      strategy.toYear = toYearObj ? toYearObj.name : null;
      strategy.roiAmount = base.numeralService.format('$0,0', strategy.roiAmount);
      strategy.stateRoiAmount = base.numeralService.format('$0,0', strategy.stateRoiAmount);
      strategy.amount = base.numeralService.format('$0,0', strategy.amount);
      strategy.actualAmount = base.numeralService.format('$0,0', strategy.actualAmount);
      strategy.dollarDifference = base.numeralService.format('$0,0', strategy.dollarDifference);
      strategy.percentageDifference = strategy.percentageDifference + '%';
      strategy.strategyType = base.getStrategy(strategy).type;

    });
    if (strategies && strategies.length > 0) {
      strategies.push(this.createTotalSavingsRow(true));
    }
    this.freezPlanStrategies = _.cloneDeep(strategies);
  }

  showStrategyInfo(row, col) {
    this.showStrategy(row);
  }

  toggleStrategyRecurring() {

  }

  toggleTaskSinglePage(row) {
    this.showTaskSinglePage(row);
  }

  showCloseYearPlanName() {
    this.showPlanNameForNewPlan = true;
  }

  setAssociatedWithForFeeItem($event, costLine) {
    costLine.associatedWith = $event.id;
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }

  addNewStrategy() {
    this.switchBoard.onDisplayFloatingWindow.next({
      title: 'Add New Strategy',
      url: ['tax-planning', 'taxStrategies', 'add']
    });
  }

  editClientInfo() {
    this.addState();
    this._router.navigate(['tax-planning', 'clients', 'edit', this.clientUserId]);
  }

  getQuestionnaireDetails(){
    if (this.organizerAccess){
      this.loadingService.triggerLoadingEvent(true);
      this.qsService.getQuestionnaireDetails(this.org, this.client.email).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.questionnaire = response;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
    }
  }

  addState() {
    this.stateService.addState(new State('client-overview', this._router.url, null, null));
  }

  setDefaultYearForROI() {
    this.roiDefaultYear = !this.roiDefaultYear;
    if (this.roiDefaultYear) {
      this.currentRoiDefaultYear = this.roiFilterYear;
      this.makeItDefaultYear(this.currentRoiDefaultYear, 'roi');
    }
  }

  makeItDefaultYear(year, graphName) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.makeDefaultYear(Session.getOrg(), this.user.id, year, graphName).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.taxPlanningService.clearDefaultYearsData();
      this.toastService.pop(TOAST_TYPE.success, 'Default year changed successfully');
    });
  }

  getDefaultYearForROI() {
    this.taxPlanningService.getDashboardDefaultYearData(Session.getOrg(), this.user.id).subscribe(response => {
      this.currentRoiDefaultYear = response.years.roi;
      this.roiDefaultYear = (this.roiFilterYear == response.years.roi) ? true : false;
    });
  }

  showStateRatesInfo(type){
    if (type == 'individual') {
      window.open('https://taxfoundation.org/publications/state-individual-income-tax-rates-and-brackets/');
    } else if (type == 'corporate') {
      window.open('https://taxfoundation.org/publications/state-corporate-income-tax-rates-and-brackets/');
    }
  }

  filterStates(stateName) {
    this.states = _.filter(this.allProvinces, function(state){
      return state.country === stateName;
    });
  }

  refreshRoiData(data) {
    if (data) {
      this.getClientTaxPlanWithNewData();
      this.getTaxPlanningSummary(this.roiView, this.roiFilterYear, data.roiCustomizedYear);
    } else {
      this.getCostLines();
      this.getClientTaxPlanWithNewData();
      this.getTaxPlanningSummary(this.roiView, this.roiFilterYear);
    }
  }

  setValuesForFilterOptions() {
    if (!this.planFilterOptions.actual) {
      this.planFilterOptions.dollarChange = false;
      this.planFilterOptions.percentageChange = false;
      this.hasActualAmount = Array.isArray(this.roiData.categories) &&
      this.roiData.categories.some(cat => cat.totalInfo?.actualAmount > 0);
    }else{
      this.hasActualAmount = false;
    }
    this.isMerged =  !this.planFilterOptions.actual;
    this.getTaxPlanningSummary(this.roiView, this.roiFilterYear);
  }

  showActualColumnForStrategies() {
    if (this.showActualColumn) {
      this.columns.splice(7, 0, {name: 'actualAmount', title: 'Actual Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''});
    } else {
      this.showDollarChangeColumn = false;
      this.showPercentageChangeColumn = false;
      this.columns = [
        {name: 'strategyName', title: 'Strategy', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true, headerColumnDesc: 'Click strategy name for details'},
        {name: 'strategyType', title: 'Category', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
        {name: 'clientName', title: 'Payor', type: 'badge-input-search', 'status-col': true, classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
        {name: 'relatedPartyType', title: 'Type', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'This can be potential or existing entity types.'},
        {name: 'associated', title: 'Fed Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
        {name: 'stateAssociated', title: 'State Associated With', type: 'badge-input-search', 'status-col': true, classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true, headerColumnDesc: 'The associated rate that applies for a given strategy. Although some strategies have default associated rates, use your professional judgement for your client’s specific situation. Rates may depend on entity type, states, or how conservative you want your ROI to be.'},
        {name: 'amount', title: 'Plan Amount', type: 'input-currency', classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Before tax amount of the tax deduction or credit.'},
        {name: 'roiAmount', title: 'Fed Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: 'Plan amount multiplied by the associated rate. This field can be overridden as needed.'},
        {name: 'stateRoiAmount', title: 'State Tax Savings', type: 'input-currency', classes: 'input-currency pointer amount-column zero-overflow amount-column-width table-header-badge-tooltip', sortable: true, format: '$0,0', skipTab: true, headerColumnDesc: ''},
        {name: 'sinceYear', title: 'Begin', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'First tax year you are applying strategy to.'},
        {name: 'toYear', title: 'End', type: 'input-search', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, headerColumnDesc: 'If the strategy is not indefinite, this is the last tax year it will apply to.'},
        {name: 'goalDate', title: 'Goal Task Date', type: 'date', classes: 'pointer zero-overflow date-column table-header-badge-tooltip', sortable: true, allowPastDate: true, initAlways: true, headerColumnDesc: 'The goal date you are expecting to implement a given strategy. This field is required to create a associated task.'}];
    }
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  showDollarChangeColumnForStrategies() {
    if (this.showDollarChangeColumn) {
      this.columns.splice(8, 0, {name: 'dollarDifference', title: '$ Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true});
    } else {
      this.columns.splice(8, 1);
    }
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  showPercentageChangeColumnForStrategies() {
    if (this.showDollarChangeColumn) {
      if (this.showPercentageChangeColumn) {
        this.columns.splice(9, 0, {name: 'percentageDifference', title: '% Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true});
      } else {
        this.columns.splice(9, 1);
      }
    } else if (this.showPercentageChangeColumn) {
      this.columns.splice(8, 0, {name: 'percentageDifference', title: '% Change', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true});
    } else {
      this.columns.splice(8, 1);
    }
    this.buildTableData(this.clientTaxPlan.strategies || []);
  }

  showTemplates(){
    this.reveal.showTemplates = true;
    // set FALSE to remaiing fields
    this.showNotes = false;
    this.showRates = false;
    this.showCostLines = false;
    this.showCashflow = false;

  }

  triggerUseTemplate($event) {
    this.reveal.showTemplates = false;
    this.reveal.useTemplate = true;
    this.useTemplateData = $event;
  }

  triggerApplyTemplate() {
    this.reveal.useTemplate = false;
    this.getClientTaxPlan();
    this.getCostLines();
  }

  onDate($event) {
    console.log($event);
  }

  triggerOnRefreshPlan(event?: any) {
    if (event && event.action === 'OPEN_IN_RAP') {
      this.openPlanInRAPMode(event.planId, event.clientId, event.planName);
      return;
    }

    if (event && event.plan) {
      if (event.plan.id !== this.taxStrategyId) {
        return;
      }
      this.clientTaxPlan = event.plan;
      return;
    }
    this.getClientTaxPlan();
  }

  /**
   * Handles the "Open in RAP" event from the plan-strategies component
   * @param event Event data (not used, we use clientTaxPlan instead)
   */
  handleOpenInRAP(event: any) {
    if (!this.clientTaxPlan || !this.clientTaxPlan.id) {
      console.error('Cannot open RAP mode: No plan data available');
      return;
    }
    
    this.openPlanInRAPMode(
      this.clientTaxPlan.id,
      this.clientTaxPlan.clientId || this.client?.id,
      this.clientTaxPlan.name
    );
  }

  /**
   * Opens a plan in RAP (Review and Planning) edit mode
   * @param planId ID of the plan to edit
   * @param clientId ID of the client
   * @param planName Name of the plan
   */
  openPlanInRAPMode(planId: string, clientId: string, planName: string) {
    this.rapEditPlanId = planId;
    this.rapEditClientId = clientId;
    this.rapEditPlanName = planName;
    this.isRapEditMode = true;
    
    this.reveal.openRapEdit = true;
  }

  closeRapEditModal() {
    this.reveal.openRapEdit = false;
    this.isRapEditMode = false;
    this.isRapMaximized = false;
    this.rapEditPlanId = null;
    this.rapEditClientId = null;
    this.rapEditPlanName = null;
    
    // Remove body class for spinner z-index
    document.body.classList.remove('rap-maximized-active');
    
    // Refresh the plan to show any committed changes
    this.getClientTaxPlan();
  }

  handleOcrData(data: any) {
    this.ocrViewJsonData = data;
  }

  handleQuestionarieData(data: any) {
    this.questionarieData = data;
  }

  /**
   * Handles successful RAP session commit
   * Closes modal, refreshes data, and shows success message
   */
  handleCommitSuccess(event?: any) {
    this.reveal.openRapEdit = false;
    this.isRapEditMode = false;
    this.isRapMaximized = false;
    this.rapEditPlanId = null;
    this.rapEditClientId = null;
    this.rapEditPlanName = null;
    
    // Remove body class for spinner z-index
    document.body.classList.remove('rap-maximized-active');
    
    const message = event?.message || 'Plan promoted to production successfully';
    this.toastService.pop(TOAST_TYPE.success, message);
    
    // Navigate based on commit mode
    const mode = event?.mode;
    const plan = event?.plan;
    const clientId = plan?.clientId || this.clientUserId;
    
    if (mode === 'CREATE_NEW' && plan?.id && plan?.taxYear && clientId) {
      // For CREATE_NEW: Navigate to the newly created plan detail page
      this._router.navigate(
        ['tax-planning', 'client', clientId, plan.id, plan.taxYear, 'client_plan'],
        { queryParams: { fromListPage: true } }
      );
    } else if (mode === 'OVERWRITE') {
      // For OVERWRITE: Stay on current plan detail page (already showing the updated plan)
      this.getClientTaxPlan(); // Refresh to show updated data
    } else if (clientId) {
      // Fallback: Navigate to client overview page
      this._router.navigate(['tax-planning', 'clients', clientId, 'overview']);
    } else {
      // Last resort fallback
      console.warn('Client ID not found, refreshing current view');
      this.getClientTaxPlan();
    }
  }
  
  /**
   * Toggle RAP modal fullscreen/maximize state
   */
  toggleRapMaximize() {
    this.isRapMaximized = !this.isRapMaximized;
    // Add/remove class on body for spinner z-index
    if (this.isRapMaximized) {
      document.body.classList.add('rap-maximized-active');
    } else {
      document.body.classList.remove('rap-maximized-active');
    }
  }

  setPaymentDate($event, cashflow) {
    if ($event) {
      cashflow.paymentDate = $event;
    }
  }

  confirm(){
    this.reveal.goalDateUpdateForPayPerPlan = false;
    this.toastService.pop(TOAST_TYPE.confirm, "Please confirm purchase of this client's plan (nonrefundable).", {
      id: this.taxStrategyId,
      type: 'plan-payment'
    });
  }

  payPerPlan(data) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.payPerPlanInfo(this.org, this.user.id, this.taxStrategyId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const paidPlans = this.taxPlanningService.getPaidPlans();
        paidPlans.push(this.taxStrategyId);
        this.taxPlanningService.setPaidPlans(paidPlans);
        this.isPaidPlan = true;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }

  switchSection(view){
    this.currentSectionView = view;
    jQuery('#a-plan-rates').attr('aria-selected', 'false');
    jQuery('#a-plan_notes').attr('aria-selected', 'false');
    jQuery('#a-plan-fees').attr('aria-selected', 'false');
    jQuery('#a-' + view).attr('aria-selected', 'true');
  }

  filterClientPlan(plan) {
    this.hasStrategies = false;
    this._router.navigate(['tax-planning', 'client', this.clientTaxPlan.clientId, plan.id, plan.year, 'client_plan'], {queryParams: {fromCreateOrDuplicatePlan: true}});
  }

  refreshCostLines() {
    this.getCostLines();
  }

  refreshCashflowLines() {
    this.getCashflowLines();
  }

  getCashflowLines(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getCashflowLines(this.org, this.user.id, this.taxStrategyId)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.formatCashflowLinesData(response);
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  // Plan Attachments changes
  startUpload($event, isOCR?) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    setTimeout(() => {
      base.uploader.uploadAll();
    }, 1000);
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.manageTaxStrategiesServices.getVideoDocumentServiceUrl(this.org, this.user.id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.taxStrategyId;
      payload.sourceType = 'PLAN_ATTACHMENT';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.uploader.progress = 100;
        this.getPlanFiles(true);
        this.updateClientStrategy();
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document');
      }
    };
  }

  startUploadForOCR($event) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    setTimeout(() => {
      base.ocrUploader.uploadAll();
    }, 1000);
  }

  resetUploader(type?) {
    this.uploader.queue.forEach((item) => {
      item.remove();
    });
  }

  getFileData(file, type?){
    this.loadingService.triggerLoadingEvent(true);
    this.manageTaxStrategiesServices.downloadDocument(this.user.id, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (type && type == 'preview') {
          window.open(response.viewDocContentURL, '_blank');
        } else {
          window.open(response.temporaryURL, '_blank');
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  getPlanFiles(refreshFiles?) {
    this.taxPlanningService.getPlanFiles(Session.getOrg(), Session.getUser().id, this.taxStrategyId).subscribe(files => {
      if (!refreshFiles) {
        this.reveal.morePlanAttachments = true;
      }
      this.planFiles = files || [];
      _.each(this.planFiles, (file) => {
        const splitArray = file.name.split('.');
        if (this.isImage(splitArray[splitArray.length - 1])) {
          file.fileType = 'image';
        } else if (splitArray[splitArray.length - 1] === 'pdf' || splitArray[splitArray.length - 1] === 'PDF') {
          file.fileType = 'pdf';
        } else {
          file.fileType = '';
        }
        // For Pollstatus code
        if (file.taskId && file.progress < 100) {
          this.pollForStatus(file);
        }
      });
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  isImage(extension){
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    if (imageTypes.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  downloadDocument(file, type?){
    this.loadingService.triggerLoadingEvent(true);
    this.manageTaxStrategiesServices.downloadDocument(this.user.id, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (type && type === 'preview') {
          window.open(response.viewDocContentURL, '_blank');
        } else {
          window.open(response.temporaryURL, '_blank');
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, "Failed to download/preview document");
      });
  }

  deleteDocumentFile(file, index){
    this.documentToRemove = file;
    this.deleteUploadedDocument();
  }

  showInfoPopup() {
    this.reveal.returnUploadDisclaimer = true;
  }

  applyCoupon() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.applyCouponForPlan(this.org, this.user.id, this.taxStrategyId, this.couponCode)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.couponSuccess = true;
        const paidPlans = this.taxPlanningService.getPaidPlans();
        paidPlans.push(this.taxStrategyId);
        this.taxPlanningService.setPaidPlans(paidPlans);
        this.isPaidPlan = true;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to apply coupon');
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to apply coupon');
        }
      });
  }

  saveUserUploadDisclaimer() {
    this.taxPlanningService.userUploadDisclaimer(this.org, this.user.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.clientTaxPlan.showUploadDisclaimer = false;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update upload disclaimer as mark read');
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update upload disclaimer as mark read');
        }
      });
  }

  deleteUploadedDocument() {
    if (this.documentToRemove) {
      this.loadingService.triggerLoadingEvent(true);
      this.manageTaxStrategiesServices.removeDocument(this.user.id, this.org, this.documentToRemove.id)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          _.remove(this.planFiles, {'id': this.documentToRemove.id});
          if(this.currentFile.id === this.documentToRemove.id){
            this.currentFile = {};
          }
          this.toastService.pop(TOAST_TYPE.success, 'Document deleted successfully');
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          try {
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to delete document');
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to delete document');
          }
        });
    }
  }

  view1040Document() {
    if (this.clientTaxPlan.documentId) {
      this.loadingService.triggerLoadingEvent(true);
      this.manageTaxStrategiesServices.downloadDocument(this.user.id, this.org, this.clientTaxPlan.documentId, '1040')
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          window.open(response.viewDocContentURL);
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          const errorMessage = 'Failed to download document';
          this.toastService.pop(TOAST_TYPE.error, errorMessage);
        });
    }
  }

}
